import React from 'react'

const Mexico = (props: React.SVGProps<SVGSVGElement>): React.ReactElement => {
    return (
        <svg
            width="45"
            height="40"
            viewBox="0 0 32 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <defs>
                <path
                    id="s"
                    fill="#CD202A"
                    d="M9 10.79h.08l.02.02-.02.2-.05.12-.15.12-.1.12-.02-.05-.02-.02.12-.12c.07-.05.14-.12.14-.2v-.19Z"
                />
            </defs>
            <g clipPath="url(#a)">
                <mask
                    id="b"
                    width="32"
                    height="30"
                    x="0"
                    y="0"
                    maskUnits="userSpaceOnUse"
                >
                    <path fill="#fff" d="M18 9A9 9 0 1 0 0 9a9 9 0 0 0 18 0Z" />
                </mask>
                <g mask="url(#b)">
                    <path fill="#CE1126" d="M-3 0h24v18H-3V0Z" />
                    <path fill="#fff" d="M-3 0h16v18H-3V0Z" />
                    <path fill="#006847" d="M-3-1h8v20h-8V-1Z" />
                    <path
                        fill="#FCCA3E"
                        d="M10.28 10.53v.14l.06-.02-.03-.15-.03.03Z"
                    />
                    <mask
                        id="c"
                        width="1"
                        height="1"
                        x="10"
                        y="10"
                        maskUnits="userSpaceOnUse"
                    >
                        <path
                            fill="#AA8C30"
                            d="M10.28 10.53v.14l.06-.02-.03-.15-.03.03Z"
                        />
                    </mask>
                    <g mask="url(#c)">
                        <path
                            fill="#AA8C30"
                            d="m10.28 10.53-.29-.29-.12.12v.17h.41Zm0 .14h-.4v.67l.59-.3-.19-.37Zm.06-.02.18.36.28-.14-.06-.3-.4.08Zm-.03-.15.4-.08-.15-.74-.54.54.3.28h-.01Zm-.44.03v.14h.82v-.14h-.82Zm.6.51.05-.03-.36-.73-.06.03.37.73Zm.27-.47-.03-.15-.8.16.03.15.8-.16Zm-.72-.35-.03.02.58.58.03-.03-.58-.57Z"
                        />
                    </g>
                    <path
                        fill="#FCCA3E"
                        d="m10.48 10.79-.11-.12-.06.03.17.12v-.03Z"
                    />
                    <mask
                        id="d"
                        width="1"
                        height="1"
                        x="10"
                        y="10"
                        maskUnits="userSpaceOnUse"
                    >
                        <path
                            fill="#AA8C30"
                            d="m10.48 10.79-.11-.12-.06.03.17.12v-.03Z"
                        />
                    </mask>
                    <g mask="url(#d)">
                        <path
                            fill="#AA8C30"
                            d="M10.48 10.79h.4v-.17l-.11-.12-.29.29Zm-.11-.12.29-.28-.21-.21-.27.13.19.36Zm-.06.03-.18-.36-.63.31.58.4.23-.35Zm.17.12-.23.34.64.42v-.76h-.41Zm.29-.32-.11-.11-.58.57.11.12.58-.58Zm-.59-.2-.05.04.36.73.06-.03-.37-.73v-.01Zm-.1.74.17.12.46-.68-.17-.12-.46.68Zm.8-.22v-.03h-.8v.03h.8Z"
                        />
                    </g>
                    <path
                        fill="#FCCA3E"
                        d="M10.48 10.84v-.08c.03-.03.06 0 .09.03l-.03.05h-.06Z"
                    />
                    <mask
                        id="e"
                        width="1"
                        height="1"
                        x="10"
                        y="10"
                        maskUnits="userSpaceOnUse"
                    >
                        <path
                            fill="#AA8C30"
                            d="M10.48 10.84v-.08c.03-.03.06 0 .09.03l-.03.05h-.06Z"
                        />
                    </mask>
                    <g mask="url(#e)">
                        <path
                            fill="#AA8C30"
                            d="M10.48 10.84h-.35v.35h.35v-.35Zm0-.08-.25-.25-.1.1v.15h.35Zm.09.03.3.15.12-.22-.18-.18-.24.25Zm-.03.05v.35h.21l.1-.19-.31-.16Zm.3 0v-.08h-.71v.08h.71Zm-.11.17a.31.31 0 0 1-.42.02l.5-.5-.13-.1a.39.39 0 0 0-.45.08l.5.5Zm-.48-.38-.03.06.63.31.03-.06-.63-.3v-.01Zm.29-.14h-.06v.7h.06v-.7Z"
                        />
                    </g>
                    <path
                        fill="#FCCA3E"
                        d="m11.41 9.03.12.15.02-.09-.1-.06h-.04Z"
                    />
                    <mask
                        id="f"
                        width="1"
                        height="1"
                        x="11"
                        y="9"
                        maskUnits="userSpaceOnUse"
                    >
                        <path
                            fill="#AA8C30"
                            d="m11.41 9.03.12.15.02-.09-.1-.06h-.04Z"
                        />
                    </mask>
                    <g mask="url(#f)">
                        <path
                            fill="#AA8C30"
                            d="M11.41 9.03v-.4h-.85l.53.66.32-.26Zm.12.15-.32.25.47.59.23-.71-.38-.13Zm.02-.09.4.13.1-.34-.31-.15-.19.36Zm-.1-.06.17-.36-.08-.04h-.1v.4h.01Zm-.36.26.12.14.64-.5-.12-.15-.64.51Zm.82.02.03-.09-.77-.26-.03.09.77.26Zm-.17-.58-.12-.06-.36.73.11.06.37-.73Zm-.3-.1h-.03v.81h.03v-.81Z"
                        />
                    </g>
                    <path
                        fill="#FCCA3E"
                        d="m11.75 9.12-.2.06v-.06l.17-.03.03.03Z"
                    />
                    <mask
                        id="g"
                        width="1"
                        height="1"
                        x="11"
                        y="9"
                        maskUnits="userSpaceOnUse"
                    >
                        <path
                            fill="#AA8C30"
                            d="m11.75 9.12-.2.06v-.06l.17-.03.03.03Z"
                        />
                    </mask>
                    <g mask="url(#g)">
                        <path
                            fill="#AA8C30"
                            d="m11.75 9.12.11.4.67-.2-.49-.49-.29.29Zm-.2.06h-.4v.54l.52-.15-.12-.4v.01Zm0-.06-.06-.4-.34.05v.35h.4Zm.17-.03.3-.29-.16-.15-.2.04.06.4Zm-.08-.36-.2.05.23.79.2-.06-.23-.78Zm.32.45v-.06h-.81v.06h.81Zm-.34.34.17-.03-.13-.8-.17.03.13.8Zm-.18-.14.02.03.58-.58-.03-.03-.57.58Z"
                        />
                    </g>
                    <path
                        fill="#FCCA3E"
                        d="m11.1 10.05-.1-.17.03-.03.11.17-.03.03h-.01Z"
                    />
                    <mask
                        id="h"
                        width="1"
                        height="2"
                        x="11"
                        y="9"
                        maskUnits="userSpaceOnUse"
                    >
                        <path
                            fill="#AA8C30"
                            d="m11.1 10.05-.1-.17.03-.03.11.17-.03.03h-.01Z"
                        />
                    </mask>
                    <g mask="url(#h)">
                        <path
                            fill="#AA8C30"
                            d="m11.1 10.05-.34.23.28.41.35-.35-.29-.29Zm-.1-.17-.29-.29-.24.24.19.28.34-.23Zm.03-.03.34-.22-.28-.42-.35.36.29.28Zm.11.17.29.3.24-.24-.19-.28-.34.22Zm.31-.2-.11-.16-.68.45.11.17.68-.45v-.01Zm-.16.35.03-.03-.58-.57-.03.02.58.58Zm-.6-.09.11.17.68-.45-.11-.17-.68.45Zm.16-.35-.03.03.58.58.03-.03-.58-.58Z"
                        />
                    </g>
                    <path
                        fill="#FCCA3E"
                        d="m11.1 10.05.17.03v-.03l-.14-.03-.03.03Z"
                    />
                    <mask
                        id="i"
                        width="1"
                        height="1"
                        x="11"
                        y="10"
                        maskUnits="userSpaceOnUse"
                    >
                        <path
                            fill="#AA8C30"
                            d="m11.1 10.05.17.03v-.03l-.14-.03-.03.03Z"
                        />
                    </mask>
                    <g mask="url(#i)">
                        <path
                            fill="#AA8C30"
                            d="m11.1 10.05-.29-.29-.56.57.79.13.06-.4v-.01Zm.17.03-.07.4.48.08v-.48h-.41Zm0-.03h.41v-.33l-.33-.07-.08.4Zm-.14-.03.08-.4-.21-.04-.16.16.3.28h-.01Zm-.1.44.17.02.14-.8-.17-.03-.13.8-.01.01Zm.65-.38v-.03h-.82v.03h.82Zm-.33-.43-.14-.03-.16.8.14.03.16-.8Zm-.5.09-.04.02.58.58.03-.03-.58-.57h.01Z"
                        />
                    </g>
                    <path
                        fill="#FCCA3E"
                        fillRule="evenodd"
                        d="M11.4 9.06a.05.05 0 1 0 0-.1.05.05 0 0 0 0 .1Zm-1.13 1.47a.06.06 0 0 0 .05-.05.06.06 0 0 0-.05-.06.05.05 0 0 0 0 .1v.01Zm1.55-1.44a.05.05 0 1 1-.1 0 .05.05 0 0 1 .1 0Zm-.84.8a.06.06 0 0 0 .04-.1.06.06 0 0 0-.04-.01.05.05 0 1 0 0 .1v.01Zm.38.2a.06.06 0 1 1-.11 0l.01-.04a.05.05 0 0 1 .09.04h.01Z"
                        clipRule="evenodd"
                    />
                    <mask
                        id="j"
                        width="2"
                        height="3"
                        x="10"
                        y="8"
                        maskUnits="userSpaceOnUse"
                    >
                        <path
                            fill="#AA8C30"
                            fillRule="evenodd"
                            d="M11.4 9.06a.05.05 0 1 0 0-.1.05.05 0 0 0 0 .1Zm-1.13 1.47a.06.06 0 0 0 .05-.05.06.06 0 0 0-.05-.06.05.05 0 0 0 0 .1v.01Zm1.55-1.44a.05.05 0 1 1-.1 0 .05.05 0 0 1 .1 0Zm-.84.8a.06.06 0 0 0 .04-.1.06.06 0 0 0-.04-.01.05.05 0 1 0 0 .1v.01Zm.38.2a.06.06 0 1 1-.11 0l.01-.04a.05.05 0 0 1 .09.04h.01Z"
                            clipRule="evenodd"
                        />
                    </mask>
                    <g mask="url(#j)">
                        <path
                            fill="#AA8C30"
                            d="M11.1 9a.3.3 0 0 1 .3-.29v.7a.4.4 0 0 0 .4-.4h-.7V9Zm.3.3a.3.3 0 0 1-.3-.3h.7a.4.4 0 0 0-.4-.4v.7Zm.3-.3a.3.3 0 0 1-.3.3v-.7a.4.4 0 0 0-.4.4h.7Zm-.3-.29c.16 0 .3.13.3.3H11c0 .22.18.4.4.4v-.7Zm-1.42 1.76c0-.16.13-.3.3-.3v.7a.4.4 0 0 0 .4-.4h-.7Zm.3.3a.3.3 0 0 1-.3-.3h.7a.4.4 0 0 0-.4-.4v.7Zm.3-.3a.3.3 0 0 1-.3.3v-.7a.4.4 0 0 0-.41.4h.71Zm-.3-.3c.16 0 .3.14.3.3h-.71c0 .23.18.4.4.4v-.7h.01Zm1.5-.68a.4.4 0 0 0 .4-.4h-.7c0-.17.13-.3.3-.3v.7Zm-.4-.4c0 .22.17.4.4.4v-.7c.16 0 .3.13.3.3h-.7Zm.4-.4a.4.4 0 0 0-.4.4h.7a.3.3 0 0 1-.3.3v-.7Zm.4.4a.4.4 0 0 0-.4-.4v.7a.3.3 0 0 1-.3-.3h.7Zm-1.5.74c0-.16.13-.3.3-.3v.7a.4.4 0 0 0 .4-.4h-.7Zm.3.3a.3.3 0 0 1-.3-.3h.7a.4.4 0 0 0-.4-.4v.7Zm.3-.3a.3.3 0 0 1-.3.3v-.7a.4.4 0 0 0-.4.4h.7Zm-.3-.3c.16 0 .3.14.3.3h-.7c0 .22.17.4.4.4v-.7Zm.32.96a.4.4 0 0 0 .4-.4H11c0-.17.14-.3.3-.3v.7Zm-.4-.4c0 .22.18.4.4.4v-.7c.17 0 .3.13.3.3h-.7Zm.4-.4a.4.4 0 0 0-.4.4h.7a.3.3 0 0 1-.3.3v-.7Zm.4.4a.4.4 0 0 0-.4-.4v.7a.3.3 0 0 1-.3-.3h.7Z"
                        />
                    </g>
                    <path fill="#FCCA3E" d="m7.65 10.56.03.17h-.05v-.17h.02Z" />
                    <mask
                        id="k"
                        width="1"
                        height="1"
                        x="7"
                        y="10"
                        maskUnits="userSpaceOnUse"
                    >
                        <path
                            fill="#AA8C30"
                            d="m7.65 10.56.03.17h-.05v-.17h.02Z"
                        />
                    </mask>
                    <g mask="url(#k)">
                        <path
                            fill="#AA8C30"
                            d="m7.65 10.56.4-.07-.05-.34h-.35v.41Zm.03.17v.4h.48l-.07-.47-.4.07h-.01Zm-.05 0h-.41v.4h.4v-.4h.01Zm0-.17v-.4h-.41v.4h.41Zm-.38.07.03.17.8-.14-.02-.17-.8.14h-.01Zm.43-.3h-.05v.8h.05v-.8Zm.35.4v-.17h-.81v.17h.81Zm-.4.24h.02v-.82h-.02v.82Z"
                        />
                    </g>
                    <path
                        fill="#FCCA3E"
                        d="M7.46 10.76h.17l-.03-.03h-.14v.03Z"
                    />
                    <mask
                        id="l"
                        width="1"
                        height="1"
                        x="7"
                        y="10"
                        maskUnits="userSpaceOnUse"
                    >
                        <path
                            fill="#AA8C30"
                            d="M7.46 10.76h.17l-.03-.03h-.14v.03Z"
                        />
                    </mask>
                    <g mask="url(#l)">
                        <path
                            fill="#AA8C30"
                            d="M7.46 10.76h-.41v.4h.4v-.4h.01Zm.17 0v.4h.98l-.7-.69-.28.29Zm-.03-.03.29-.29-.12-.12H7.6v.41Zm-.14 0v-.4h-.41v.4h.41Zm0 .44h.17v-.82h-.17v.82Zm.45-.7-.02-.03-.58.58.03.03.57-.58Zm-.31-.15h-.14v.82h.14v-.82Zm-.55.41v.03h.82v-.03h-.82Z"
                        />
                    </g>
                    <path fill="#FCCA3E" d="M6.9 9.88v.17l-.04-.03v-.14h.04Z" />
                    <mask
                        id="m"
                        width="1"
                        height="2"
                        x="6"
                        y="9"
                        maskUnits="userSpaceOnUse"
                    >
                        <path
                            fill="#AA8C30"
                            d="M6.9 9.88v.17l-.04-.03v-.14h.04Z"
                        />
                    </mask>
                    <g mask="url(#m)">
                        <path
                            fill="#AA8C30"
                            d="M6.9 9.88h.4v-.4h-.4v.4Zm0 .17-.3.3.7.69v-.99h-.4Zm-.04-.03h-.4v.17l.11.12.3-.29h-.01Zm0-.14v-.4h-.4v.4h.4Zm-.38 0v.17h.82v-.17h-.82Zm.7-.12-.03-.03-.58.58.03.03.58-.58Zm.1.26v-.14h-.83v.14h.83Zm-.42.27h.03v-.82h-.03v.82Z"
                        />
                    </g>
                    <path
                        fill="#FCCA3E"
                        d="m6.7 10.05.13-.03.06.06-.2-.03h.01Z"
                    />
                    <mask
                        id="n"
                        width="1"
                        height="1"
                        x="6"
                        y="10"
                        maskUnits="userSpaceOnUse"
                    >
                        <path
                            fill="#AA8C30"
                            d="m6.7 10.05.13-.03.06.06-.2-.03h.01Z"
                        />
                    </mask>
                    <g mask="url(#n)">
                        <path
                            fill="#AA8C30"
                            d="m6.7 10.05-.09-.4.03.8.05-.4h.01Zm.13-.03.3-.28-.16-.16-.22.04.08.4Zm.06.06-.06.4 1.22.18-.87-.87-.29.3v-.01Zm-.12.37.14-.02-.16-.8-.14.02.16.8Zm-.22-.14.05.06.58-.58-.06-.05-.57.57Zm.4-.63-.2-.03-.11.8.2.04.1-.81h.01Z"
                        />
                    </g>
                    <path
                        fill="#FCCA3E"
                        d="M6.38 9.18 6.47 9h-.03l-.09.11.03.06v.01Z"
                    />
                    <mask
                        id="o"
                        width="1"
                        height="1"
                        x="6"
                        y="9"
                        maskUnits="userSpaceOnUse"
                    >
                        <path
                            fill="#AA8C30"
                            d="M6.38 9.18 6.47 9h-.03l-.09.11.03.06v.01Z"
                        />
                    </mask>
                    <g mask="url(#o)">
                        <path
                            fill="#AA8C30"
                            d="m6.38 9.18-.36.18.36.73.37-.73-.37-.18ZM6.47 9l.36.18.3-.6h-.66V9Zm-.03 0v-.4h-.2l-.13.16.33.25V9Zm-.09.11-.32-.25-.15.2.1.23.37-.18Zm.4.24.08-.17-.73-.37-.08.17.73.37Zm-.28-.76h-.03v.82h.03v-.82Zm-.36.16-.08.11.65.5.09-.12-.66-.49ZM6 9.3l.03.06.73-.37-.03-.05L6 9.3Z"
                        />
                    </g>
                    <path
                        fill="#FCCA3E"
                        d="m6.44 9-.03-.08h.03l.06.03h.02v.06h-.08V9Zm-.31-.02.03.05H6.1c-.03 0-.06-.02-.03-.05h.06Z"
                    />
                    <mask
                        id="p"
                        width="1"
                        height="2"
                        x="6"
                        y="8"
                        maskUnits="userSpaceOnUse"
                    >
                        <path
                            fill="#AA8C30"
                            d="m6.44 9-.03-.08h.03l.06.03h.02v.06h-.08V9Zm-.31-.02.03.05H6.1c-.03 0-.06-.02-.03-.05h.06Z"
                        />
                    </mask>
                    <g mask="url(#p)">
                        <path
                            fill="#AA8C30"
                            d="m6.44 9-.33.12.08.24h.25V9Zm-.03-.08v-.35h-.49l.16.46.33-.1v-.01Zm.03 0 .16-.31-.08-.04h-.08v.35Zm.06.03-.16.31.07.04h.09v-.35Zm.02 0h.35V8.6h-.35v.35Zm0 .06v.35h.35V9h-.35v.01Zm-.4-.03.32-.16-.1-.2h-.21v.36h-.01Zm.04.05v.36h.56l-.25-.51-.31.15Zm-.09-.05v-.35h-.14l-.1.1.24.25Zm.7-.08-.03-.09-.66.22.03.09.66-.22Zm-.36.37h.03v-.7H6.4v.7h.01Zm-.13-.03.06.02.31-.62-.05-.03-.32.63Zm.22.06h.02v-.7H6.5v.7Zm-.33-.35v.06h.7v-.06h-.7Zm.35-.3h-.08v.7h.08v-.7Zm-.7.48.02.06.63-.31-.03-.06-.63.31h.01Zm.34-.45H6.1v.7h.06v-.7Zm-.06 0a.3.3 0 0 1 .26.14.32.32 0 0 1-.04.4l-.5-.49a.38.38 0 0 0-.05.48.4.4 0 0 0 .33.18v-.71Zm-.03.65h.06v-.7h-.06v.7Z"
                        />
                    </g>
                    <path
                        fill="#FCCA3E"
                        d="m6.21 9.06.14.09v.05l-.17-.1.03-.04Z"
                    />
                    <mask
                        id="q"
                        width="1"
                        height="1"
                        x="6"
                        y="9"
                        maskUnits="userSpaceOnUse"
                    >
                        <path
                            fill="#AA8C30"
                            d="m6.21 9.06.14.09v.05l-.17-.1.03-.04Z"
                        />
                    </mask>
                    <g mask="url(#q)">
                        <path
                            fill="#AA8C30"
                            d="m6.21 9.06.21-.35-.27-.16-.23.22.3.3-.01-.01Zm.14.09h.41v-.23l-.2-.12-.2.35h-.01Zm0 .05-.22.34.63.43V9.2h-.41Zm-.17-.1-.28-.3-.36.36.42.27.22-.34v.01ZM6 9.4l.14.09.42-.7-.14-.09-.42.7Zm-.05-.26v.05h.81v-.05h-.81Zm.63-.29-.17-.1-.45.67.17.11.45-.68Zm-.1.52.02-.03-.58-.58-.02.03.57.58h.01Z"
                        />
                    </g>
                    <path
                        fill="#FCCA3E"
                        d="M6.21 9.1h-.08v-.04l.03-.03.02-.05c.03-.03.03 0 .03.03v.09Z"
                    />
                    <mask
                        id="r"
                        width="1"
                        height="2"
                        x="6"
                        y="8"
                        maskUnits="userSpaceOnUse"
                    >
                        <path
                            fill="#AA8C30"
                            d="M6.21 9.1h-.08v-.04l.03-.03.02-.05c.03-.03.03 0 .03.03v.09Z"
                        />
                    </mask>
                    <g mask="url(#r)">
                        <path
                            fill="#AA8C30"
                            d="M6.21 9.1v.34h.35V9.1h-.35Zm-.08 0h-.35v.34h.35V9.1Zm0-.04-.25-.24-.1.1v.14h.35Zm.03-.03.24.25.04-.04.03-.05-.31-.16Zm.02-.05-.24-.25-.04.04-.03.05.31.16Zm.03-.24h-.08v.7h.08v-.7Zm.27.35v-.03h-.7v.03h.7Zm-.1.22.02-.03-.5-.5-.02.04.5.5v-.01Zm.09-.12.03-.05-.63-.32-.03.06.63.31Zm-.04.04-.04.03A.34.34 0 0 1 5.86 9c0-.01 0 0 0 0h.7v-.05s0-.08-.04-.15a.36.36 0 0 0-.4-.19c-.1.03-.17.1-.18.11l.5.5-.01.01ZM5.86 9v.08h.7V9h-.7Z"
                        />
                    </g>
                    <path
                        fill="#AA8C30"
                        d="M6.44 9.02v.03l-.03.05.05-.08L6.44 9v.02Zm-.2.05v.03l.08.1-.12-.1.02-.03h.02Zm-.04.03h-.03l-.05-.03v-.02.05l.05.02.03-.02Zm-.08-.05L6.08 9v.05h.04Z"
                    />
                    <path
                        fill="#9CA168"
                        d="M11.9 8.69c0 .14-.14.21-.21.26l-.1.12-.02.1-.03.05v.02l.03.07-.03.15.1-.07.07-.03h.03l-.1.17c-.02.1-.1.27-.2.32-.11.07-.19.05-.21.07l-.05.05-.05.05-.02.04-.05.03v.02l-.03.08-.02.07h.05l.05-.03-.03.08c0 .02 0 .17-.14.24-.15.07-.49.07-.49.07l-.07.03-.05.04-.07.08v.02l-.07.07-.1.08h.07l.12.04-.12.03c-.04.02-.31.17-.43.14-.12-.02-.3-.17-.3-.17l-.06-.04-.13-.03-.16-.02v-.05l.14.02.17.03h.12l.22-.17.22-.1.1.03h.02l.05.02-.05.02-.05.05.02.03.15-.03h.02l.03.03.02-.05.12-.12.05-.03.05-.12.02-.07.15-.15.1-.1.04-.11v-.03s.03.03.03.1l-.03.12.17-.1.07-.02.1-.07.03-.08v-.36l.1-.2.11-.11.03-.03v.05l-.03.05.12-.1a.27.27 0 0 0 .03-.07l.02-.12v-.12l-.02-.08-.05-.16v-.22l-.05-.05s.05 0 .1.07l.07.17.12-.36.05.12.02.12.05-.1v.03c.03.05.1.07.08.22h-.01ZM9.42 11.1s-.02-.04-.14-.12c-.12-.07-.2-.07-.2-.07v.05l.2.07.07.1.07-.03Z"
                    />
                    <path
                        fill="#717732"
                        d="m10.26 10.74.17-.12.12-.02c.07-.03.07 0 .24-.1.17-.1.2-.2.22-.22l.1-.05-.12.15-.22.17-.3.07-.14.07a.53.53 0 0 0-.07.1v-.05Zm.46-.46c-.14.15-.2.27-.2.27l.2-.2.2-.12.1-.12.04-.02s-.07-.05-.34.2v-.01Zm-.31.32s.04-.03.07-.1l.05-.1.21-.21c.1-.13.05-.2.05-.2l-.02.1c-.03.05-.24.17-.27.26l-.02.13c-.03.1-.07.12-.07.12Zm-.13.38s-.07-.04-.16-.04c-.17.02-.32.12-.44.12s-.17-.05-.27-.12c-.1-.05-.33-.05-.33-.05v.02h.24c.12.05.2.2.36.2.2-.03.36-.15.44-.15l.16.02Zm-.89-.1s.14.03.27-.04c.12-.07.24-.2.29-.2l.14.03-.14-.05-.22.05c-.07.02-.1.12-.17.17l-.17.05v-.01Zm-.02.2-.05.02-.1-.1c-.05-.04-.14-.04-.14-.04v.02l.14.05.1.07.05.03.04-.03-.04-.02Zm.12-.12.14.02c.2 0 .32-.14.44-.19.12-.05.2 0 .2 0v-.02l-.15-.05c-.22.02-.42.14-.51.2l-.12.04Zm2.05-1.5-.2.36c-.01.08-.09.08-.11.1l-.12.14-.05.03v.02l.07-.07.07-.1.2-.14.2-.34.14-.1s-.08-.02-.2.1Zm-.34.41.05-.1.12-.12c.05-.07.05-.17.08-.26l.1-.17s-.06 0-.1.07l-.2.31c-.05.13-.05.27-.05.27Zm-.04.1.02-.12.02-.34.2-.27-.17.1c-.1.07-.15.17-.12.24l.05.24v.15Zm.38-.75.05-.2.12-.14c.05-.05.1-.1.1-.17l.02-.27-.02.05-.05.24-.14.25.02-.22.05-.22.02-.24s-.07.05-.1.12l-.04.29.02.22v.12l-.02.07-.03.1Zm-.12-.8s.05.05.03.12a.4.4 0 0 0 0 .24l.1.15v.12-.22l-.06-.07v-.24c0-.08-.07-.1-.07-.1Z"
                    />
                    <path
                        fill="#9CA168"
                        d="m8.47 11.08.1-.07.26-.12v.07l-.1.02-.07.05-.1.05h-.09Z"
                    />
                    <path
                        fill="#9CA168"
                        d="m8.71 10.81-.22.05h-.04l-.05-.05-.03-.02-.02.1-.17-.17-.02.12-.03.05-.2-.2v.15H7.9l-.12-.1-.05.03.05.07-.17.02-.02.03-.05.05h.07l.02-.03.03.05c.02 0 .1-.05.17-.02.05.02-.1.07-.08.1.03.04.13.02.15.02.02-.03.1-.12.14-.08.05.05-.1.1-.07.15.03.05.1.02.15 0 .05-.03.12-.15.14-.12.03.05-.1.1-.05.14.05.05.08 0 .13-.02l.1-.12.06-.03.05-.04.15-.05h.05l.02.02h.07v-.05l-.12-.05h-.01Zm-1.01 0 .02-.04-.1-.08-.07-.07-.07-.05-.05-.1v-.02h-.05l-.07-.22v-.04h-.05l-.05.14-.05-.1-.02-.17-.02.03-.05.05-.1-.17v.12a.94.94 0 0 1-.22-.2l-.05-.1.03-.06.02-.1-.07.02-.02-.19v-.07l-.1.14-.05-.07v-.12L6.5 9.3l-.05.08-.05-.1v-.14l-.05-.2.03-.1h-.03c.03-.02.15-.12.12-.16-.02-.05-.14.07-.12 0 .03-.08.15-.08.15-.2 0-.05-.1.05-.12.03-.03-.03.07-.12.07-.15V8.3c-.03-.03-.1.1-.1.1l-.07-.05-.05.12-.02.1-.1-.08.05.12.02.12-.12-.02.07.1.05.07.05.05.02.02.05.03.03.07.02.07v.22c-.02 0-.05-.05-.07-.03 0 .03.07.08.05.1-.03.03-.12-.02-.12 0 0 .03 0 .1.07.1s.2.05.17.07c-.03.02-.17-.07-.17 0s.07.12.1.12c.02 0 .19 0 .19.05s-.12-.02-.15.05c-.02.07.08.05.1.05l.12.02c.1.1.2.18.32.27l-.1.02c0 .03.24.1.17.12-.07.03-.15-.07-.17 0-.02.07.05.1.07.12.03.03.27.03.22.08-.05.02-.2-.05-.2.02s.1.15.15.12c.05 0 .12-.07.15-.02.02.05-.05.05 0 .07.04.02.1-.05.14-.05l.22.1.1.1-.01-.01Z"
                    />
                    <path
                        fill="#717732"
                        d="m8.52 11.06.05.02.12-.07-.12.1-.05.02c-.05 0-.05-.03-.05-.05l.05-.02Zm.31-.15-.05-.02-.1-.03-.14.08-.05.04.08-.04.14-.05.07.02.05.03v-.03Zm-1.86-.77v-.03l-.1-.05-.17-.12.1.1.15.1h.02Zm1.3.94.08-.1.07-.07-.02-.05-.03-.05.05.05.03.05.07-.02-.03-.03h-.02l-.1-.1-.02.08c-.05 0-.07-.15-.2-.17l-.1.02c-.02 0 .1.12.08.15-.02 0-.14-.17-.22-.17-.07 0-.07.02-.07.05 0 .02.1.02.07.07-.02.07-.1-.07-.14-.05l-.1.03.03.04-.1.03-.07.1s.05-.08.1-.08h.21l-.05-.02-.05-.07.08.04c.02.05.07.05.07.05l.07.03-.02.05.05-.05.04.02s.03-.02-.02-.07l-.05-.1.07.1.05.07h.05c.03 0 .03.03-.02.05-.05.02-.03.1-.03.1l.05-.08.05-.07.07.03-.05-.08-.02-.1.05.1.05.08h.07l-.02.07-.05.07h-.01Zm-.8-.46h.08s-.07-.02-.07-.07 0-.17-.03-.17c-.02 0-.04.07-.07.07l-.02-.24c-.03-.05-.1-.1-.12-.07 0 .02 0 .14-.05.12-.05-.03 0-.15 0-.2 0-.04-.05-.1-.07-.07-.03.03 0 .12-.03.12l-.05-.1H7l-.02-.04v.07l.02.05.05.05-.05.02h-.07l.07.03h.08l.05.07v-.07l.02-.1v.1l-.02.1.04.04h-.24l.12.02.15.03.05.07.04-.12v-.12.27l-.07.02-.14.02h.14l.07-.02.05.02.05.05-.05.03-.05.02.08-.02.05-.03h.02v-.05.08l.05.02h-.02ZM6.35 9.3v-.12l-.05-.22h-.02l.05-.07-.05.05-.05-.03-.02-.02.04.02h.03l-.03-.07-.07-.02-.1-.08.1.05.07.03.05-.03.08-.05-.08.03h-.05l-.02-.07-.02-.05-.08-.1.08.05.04.07.05-.05.12-.07-.12.05-.05.02v-.05l.03-.07-.03-.02c-.02-.03.03-.1.03-.1v.05l.02.05.12-.12c0-.03.05-.08-.02-.05-.05.02-.02.05-.07.05-.03 0-.03-.05-.05-.03l-.05.08-.02.12c-.03.02-.05-.08-.08-.05l-.04.1c.02.02.1.12.07.14-.03.02-.12-.1-.15-.02-.02.07.12.14.15.16l.02.05.1.08.07.21v.1Zm.44.63s-.05-.05-.03-.12l.05-.22s-.07.07-.1.05c-.02-.03.03-.15 0-.22-.02-.07-.02-.1-.07-.07-.05.02-.07.14-.1.12v-.12c-.02-.03-.02-.07-.04-.05l-.05.07c-.03 0-.05-.1-.07-.07-.05 0 .07.17.07.17l.05-.05.02-.05v.05l-.02.07h-.1l-.1-.02.1.05.1.02.02.05.05.05s0-.03.03-.07l.05-.15-.03.15-.02.12-.1-.03-.14-.02.14.05.1.02.05.07.04-.04-.02.04-.05.03h-.1l.1.02h.07l.03.05.05.05h.02Z"
                    />
                    <path
                        fill="#CD202A"
                        d="M9.41 11.27H9.3l-.07-.07-.12-.05-.07-.07.02-.1.1.1.17.1.1.1-.02-.01Z"
                    />
                    <path
                        fill="#30C2DC"
                        d="M9.87 10.4s-.12-.05-.12-.1c0-.04.32-.11.32-.11v-.08l-.12.03-.32.05-.14-.03-1.14-.05c-.12-.02-.22-.24-.22-.24l-.07.03s.02.1 0 .12c-.07 0-.53-.25-.53-.25l-.03.1s.3.15.27.22c-.03.07-.07.05-.07.05l.02.07s.46 0 .46.14c0 .05-.12.08-.12.08l.05.05v.02s.24 0 .31.05l.17.14c.07.05.65.03.75 0 .1-.02.15-.14.32-.19l.21-.05v-.05Z"
                    />
                    <path
                        fill="#F9AA51"
                        d="M9 10.03 8.95 10h-.28l.14.4.17.23.09.03h.14v-.08l-.03-.37-.2-.18H9Z"
                    />
                    <path
                        fill="#953220"
                        fillRule="evenodd"
                        d="M8.67 10h.3l.23.2v.01l.03.37v.08h-.15l-.1-.02-.17-.24-.14-.4Zm.02.01.14.38.17.24.08.02h.13v-.07l-.03-.36-.22-.2h-.27v-.01Z"
                        clipRule="evenodd"
                    />
                    <path
                        fill="#F9AA51"
                        d="M8.51 10.06V10h.17l.14.19c.03.08.06.2.12.26l.14.21H8.9l-.09-.03-.25-.36-.06-.21h.01Z"
                    />
                    <path
                        fill="#953220"
                        fillRule="evenodd"
                        d="M8.5 10h.18l.15.18.02.07.03.08a.3.3 0 0 0 .06.12l.15.2v.01H8.9l-.1-.02-.25-.37-.06-.21V10h.01Zm.02.01v.05l.06.2.25.37.08.02h.15l-.13-.2a.33.33 0 0 1-.07-.12 1.8 1.8 0 0 1-.03-.08l-.02-.06-.13-.18h-.16Z"
                        clipRule="evenodd"
                    />
                    <path
                        fill="#F9AA51"
                        d="M8.4 10h.11l.17.21.09.27.14.18h-.29c-.1 0-.1-.03-.14-.05l-.08-.06h-.1l.03-.1-.03-.29v-.13l.1-.03Zm1.02.08L9.25 10h-.31l.02.14.12.31.14.21c.03.03.2-.05.2-.05l.11-.03-.03-.1v-.42l-.08.02Z"
                    />
                    <path
                        fill="#953220"
                        fillRule="evenodd"
                        d="M8.4 10h.11l.18.2v.01l.08.26.15.18v.01h-.4a.1.1 0 0 1-.03-.03l-.01-.02-.09-.05h-.08l.02-.11-.03-.29v-.13h.01l.08-.03h.01Zm0 .01-.08.03v.12l.03.29-.02.1h.07l.09.05.01.02.03.02.1.01h.26l-.13-.17-.09-.26-.16-.2H8.4v-.01Zm.53-.01h.32l.17.07.08-.02h.01v.42l.03.1v.02l-.12.03-.16.05h-.05l-.14-.22-.12-.31-.02-.13V10Zm.48.6.1-.03-.02-.1v-.4l-.07.02-.18-.08h-.3l.03.12.12.32.14.2h.03c.02 0 .04 0 .06-.02l.1-.03h-.01Z"
                        clipRule="evenodd"
                    />
                    <path
                        fill="#F9AA51"
                        d="m8.34 10.08.06.03s.05 0 .05-.05c0-.06-.02-.08-.1-.1-.1-.03-.12.07-.12.12l.05.08s-.05.05-.05.13.08.16.08.16-.08.05-.08.1c0 .06.05.08.11.08s.14-.02.14-.05c0-.05-.05-.08-.08-.08l-.06.03m1.13-.42-.05.03c-.03 0-.06 0-.06-.06 0-.05.06-.08.11-.08.06 0 .12.06.12.14 0 .07-.02.09-.02.09l-.01.09c0 .08-.06.13-.06.13s.09.03.09.1c0 .08-.09.11-.12.11-.02 0-.11-.03-.11-.08s.03-.08.06-.08l.05.05"
                    />
                    <path
                        fill="#953220"
                        fillRule="evenodd"
                        d="M8.28 9.95h.06c.05 0 .08.02.1.04.02.02.02.04.02.07v.03l-.03.02H8.4l-.06-.02v-.01l.06.02h.02l.02-.02v-.02c0-.03 0-.04-.02-.06a.22.22 0 0 0-.08-.04h-.05a.08.08 0 0 0-.03.03.2.2 0 0 0-.02.09l.05.08v.01a.19.19 0 0 0-.05.12c0 .04.02.08.04.1 0 .02.02.03.03.04v.01h.01v.02H8.3l-.03.03a.17.17 0 0 0-.03.03l-.01.03c0 .03.01.04.03.06l.07.01a.3.3 0 0 0 .09-.01l.03-.02h.01a.06.06 0 0 0-.03-.06.09.09 0 0 0-.04-.02l-.05.03h-.02v-.02l.06-.03a.1.1 0 0 1 .07.02.1.1 0 0 1 .03.07c0 .01 0 .02-.02.03l-.03.02a.31.31 0 0 1-.1.01c-.03 0-.06 0-.08-.02a.08.08 0 0 1-.04-.07l.01-.04a.2.2 0 0 1 .03-.03l.03-.03a.4.4 0 0 1-.03-.04.2.2 0 0 1-.04-.12c0-.04.02-.09.05-.12l-.05-.08c0-.03 0-.08.02-.1a.1.1 0 0 1 .04-.04h.01Zm1.12.08s-.03.03-.03.05l.01.04h.03l.06-.02h.01v.02l-.06.02h-.05l-.02-.06c0-.03.02-.05.04-.06a.16.16 0 0 1 .08-.02c.07 0 .13.05.13.14 0 .04-.02.06-.04.07l-.02.01.03.1c0 .05-.02.1-.05.13 0 0 .02 0 .03.02a.1.1 0 0 1 .05.08.1.1 0 0 1-.05.1.15.15 0 0 1-.08.02c-.01 0-.04 0-.07-.02-.02-.02-.05-.04-.05-.07 0-.05.03-.09.07-.09l.06.06v.01h-.01l-.06-.05c-.02 0-.04.02-.04.07 0 .02.02.04.04.05l.06.02c.02 0 .04 0 .07-.02a.09.09 0 0 0 .04-.08.1.1 0 0 0-.04-.07.14.14 0 0 0-.04-.02l.05-.1m-.02-.16h.02c.01-.01.03-.03.03-.06 0-.08-.06-.13-.1-.13l-.08.02m.12.18h.01Z"
                        clipRule="evenodd"
                    />
                    <path
                        fill="#231F20"
                        d="m9.95 10.02-.08-.03v-.07l.03.02.05.08Zm.36-.1.05.05.05.02-.08-.02-.05-.05h.03Zm.12.02-.05.03-.05-.05h.05l.05.02Zm.2-.14h-.1l.07-.03.02.03h.01Zm-.3-.41-.05.05v.04l.03-.04.02-.05Zm-.19.12-.02.02v.07l.02-.04V9.5v.01Z"
                    />
                    <path
                        fill="#8CBEBF"
                        d="m9.8 9.75-.1.1s.25.14.42.14c.19-.02.4-.17.43-.2l-.02-.19c-.03-.02-.17-.14-.22-.14-.05 0-.12.07-.22.14-.1.08-.07.15-.17.15H9.8Z"
                    />
                    <mask
                        id="t"
                        width="2"
                        height="1"
                        x="9"
                        y="9"
                        maskUnits="userSpaceOnUse"
                    >
                        <path
                            fill="#04534E"
                            d="m9.8 9.75-.1.1s.25.14.42.14c.19-.02.4-.17.43-.2l-.02-.19c-.03-.02-.17-.14-.22-.14-.05 0-.12.07-.22.14-.1.08-.07.15-.17.15H9.8Z"
                        />
                    </mask>
                    <g mask="url(#t)">
                        <path
                            fill="#04534E"
                            d="M9.8 9.75v-.7h-.29l-.2.2.5.5H9.8Zm-.1.1-.5-.5-.63.64.77.46.36-.6Zm.42.14v.7h.08l-.08-.7Zm.43-.2.5.5.24-.24-.04-.34-.7.09v-.01Zm-.02-.19.7-.08-.04-.24-.17-.17-.5.5.01-.01ZM9.3 9.25l-.1.1.99 1 .1-.1-1-1h.01Zm.4.6-.37.6h.01l.02.01c.23.13.49.2.75.23V9.3h.06l-.05-.01a.85.85 0 0 1-.05-.03h-.02l-.36.6.01-.01Zm.5.84a1.58 1.58 0 0 0 .84-.4l-1-.99a.66.66 0 0 1 .07-.05.48.48 0 0 1-.1.05l.18 1.39h.01Zm1.04-.98-.03-.2-1.39.18.03.2 1.39-.18Zm-.23-.6a1.74 1.74 0 0 0-.44-.3.76.76 0 0 0-.27-.05v1.4c-.1 0-.2-.02-.3-.07l.04.03-.02-.02 1-1-.01.01Zm-.71-.35a.79.79 0 0 0-.37.1l-.14.08-.08.06-.05.04.84 1.13.13-.1-.05.02a.58.58 0 0 1-.28.07v-1.4Zm-.64.28a.97.97 0 0 0-.24.26v.02c0-.01.06-.1.18-.18.1-.06.2-.1.31-.1v1.41a.8.8 0 0 0 .67-.36c.05-.07 0 .02-.08.08l-.84-1.13Zm.25 0H9.8v1.41h.12v-1.4l-.01-.01Z"
                        />
                    </g>
                    <path
                        fill="#0C8489"
                        d="M9.78 9.77s.26.05.34-.02l.19-.22.1-.02.04.02.08.07.02.13v.07l-.1.05-.14.07-.15.05h-.12l-.24-.08-.07-.04.05-.08Z"
                    />
                    <path
                        fill="#04534E"
                        d="m10.16 9.63.05-.03.03.03-.03.07-.05-.07Zm.12.07.03-.02.05.05-.05.02-.03-.05Zm-.04.15.04-.03.03.05-.03.02-.04-.04Zm-.15-.05.05-.03.05.05-.05.05-.05-.07Zm-.22.02a.06.06 0 1 1 .12 0 .06.06 0 0 1-.12 0Z"
                    />
                    <path
                        fill="#8CBEBF"
                        d="m10.28 9.7.03-.02.02.02-.02.03-.03-.03Zm-.04.15.04-.03.03.03-.03.04-.04-.04Zm-.15-.05.07-.03v.03l-.02.05-.05-.05Zm.07-.17.03-.03.02.03-.02.05-.03-.05Zm-.29.2c0-.03.03-.06.08-.06l.04.03c0 .02-.02.07-.07.07s-.05-.02-.05-.05v.01Z"
                    />
                    <path
                        fill="#231F20"
                        d="m10 9.77-.08.03v.05l.03-.03.04-.05H10Zm.16-.04-.04.04v.05l.02-.05.02-.04Zm.03.04-.05.03-.02.02.04-.02.03-.03Zm.02-.19-.02.02v.03l.02-.03v-.02Zm.15.07-.05.03v.02l.02-.02.03-.03Zm-.03.17-.02.03h-.05c-.02-.03.02-.03.02-.03h.05Z"
                    />
                    <path
                        fill="#04534E"
                        d="M10.55 9.7s0 .07-.05.12c-.07.03-.24.15-.4.15-.18 0-.37-.12-.37-.12l-.03.02h.05l.12.07.15.03.1.02.07-.02.14-.05.15-.05.05-.07h.02v-.1Z"
                    />
                    <path
                        fill="#231F20"
                        d="m7.28 8.76.03.07c0 .02 0 .05-.03.02v-.1.01Zm.3.26-.05.08c-.03.02-.03-.03-.03-.03l.03-.02.05-.03Zm-.63.05.04.03.03-.03h-.07Zm.12.22.05.02a.05.05 0 0 0 .04-.02h-.1.01Zm.2.17.04-.02.02-.05-.05.02-.02.05h.01Z"
                    />
                    <path
                        fill="#8CBEBF"
                        d="M7.58 9.31s.02-.21-.15-.38c-.17-.17-.31-.12-.39-.05-.05.05-.1.24.1.41.2.17.44.12.44.12v-.1Z"
                    />
                    <mask
                        id="u"
                        width="2"
                        height="2"
                        x="6"
                        y="8"
                        maskUnits="userSpaceOnUse"
                    >
                        <path
                            fill="#04534E"
                            d="M7.58 9.31s.02-.21-.15-.38c-.17-.17-.31-.12-.39-.05-.05.05-.1.24.1.41.2.17.44.12.44.12v-.1Z"
                        />
                    </mask>
                    <g mask="url(#u)">
                        <path
                            fill="#04534E"
                            d="m7.58 9.31-.7-.07v.07h.7Zm0 .1.13.69.57-.11V9.4h-.7v.01Zm0-.1.7.08v-.12c0-.31-.13-.62-.35-.84l-1 1a.2.2 0 0 1-.05-.1v-.09l.7.07Zm.35-.88a1.03 1.03 0 0 0-.73-.32c-.24 0-.48.1-.65.27l.99 1a.48.48 0 0 1-.34.13.4.4 0 0 1-.27-.09l1-.99Zm-1.38-.05a.91.91 0 0 0-.25.71c.02.27.15.53.38.73l.92-1.06c.04.03.09.1.1.22 0 .05 0 .1-.02.16a.56.56 0 0 1-.14.23l-1-.99h.01Zm.13 1.44a1.22 1.22 0 0 0 1.03.28 85 85 0 0 0-.27-1.38h.06c.02 0 .06 0 .1.04l-.92 1.06Zm1.6-.4v-.1h-1.4v.1h1.4Z"
                        />
                    </g>
                    <path
                        fill="#0C8489"
                        d="M7.02 9.07s-.03-.12.05-.14c.05-.05.24-.08.34.1.1.19.1.28.07.38h-.1l-.14-.07-.15-.1-.07-.17Z"
                    />
                    <path
                        fill="#04534E"
                        d="m7.55 9.36-.1.03c-.04 0-.38-.08-.46-.37v.08l.03.07.07.1.07.07.1.05.07.02h.17l.05-.05Zm-.17-.1.03-.02.04.03-.04.04-.03-.04v-.01Zm.03-.14.02-.02.02.02-.02.05-.02-.05Zm-.15.17.02-.02.05.02-.05.02-.02-.02Zm-.02-.17.04-.02.03.02-.03.07-.04-.07Zm-.12.02.02-.04.05.04-.03.03-.04-.03ZM7.14 9l.02-.02.05.02-.05.05L7.14 9Zm.14-.02h.03l.05.02-.05.05-.03-.07Z"
                    />
                    <path
                        fill="#8CBEBF"
                        d="m7.14 9 .02-.02.03.02-.03.02L7.14 9Zm-.02.14.02-.04.02.02-.02.05-.02-.03Zm.16-.16h.05L7.31 9l-.03-.02Zm-.04.14.04.05.03-.05-.03-.02-.04.02Zm.17-.02.02.04.05-.04-.05-.03-.02.03Zm-.15.19.02-.02.03.02-.05.02v-.02Zm.12-.02.05-.03.02.03-.04.02-.03-.02Z"
                    />
                    <path
                        fill="#231F20"
                        d="m7.43 9.02.02.05-.02.05v-.1Zm-.12-.12V9l-.03-.05.03-.05Zm-.15.03.03.05-.03.02v-.07Zm-.04.02a.1.1 0 0 0 .04.03V9h-.02l-.02-.05Zm.1.15.04.02.02.02-.04-.02-.03-.02h.01Zm-.13 0 .05.02v.02l-.02-.02-.03-.02Zm.32.1v.09l-.03-.05.03-.05v.01Zm-.05.04.05.03v.02l-.03-.02-.02-.03Zm-.12 0 .02.03.02.02h-.02l-.02-.05Z"
                    />
                    <path
                        fill="#04534E"
                        d="M7.19 8.83s-.12.02-.15.1l-.02.17-.03-.1.03-.07.02-.05.08-.05h.07Zm.36.46-.02-.12-.1-.22.05.05.05.07.02.07.03.08v.05l-.03.02Z"
                    />
                    <path
                        fill="#231F20"
                        d="m7.67 9.14.05.03v.02l-.02-.02-.03-.03Zm-.17.46.05-.04h.05l-.02.04H7.5Zm.3.13.04-.03.03-.05-.05.03-.03.05h.01Zm-.03-.03.02-.05.03-.02v.05l-.05.02Z"
                    />
                    <path
                        fill="#0C8489"
                        d="m8.06 9.29.1.1.02.1-.31-.2c-.13-.05-.27 0-.3.07-.02.08-.02.17.05.2.05.04.34.1.34.1l.15-.03.1-.05v-.05l.02-.05.02-.02-.07-.07-.12-.1Z"
                    />
                    <path
                        fill="#04534E"
                        d="m7.82 9.31-.05.05-.03-.05.03-.02.05.02Zm-.17.08.02-.03.05.05-.05.03-.02-.05Zm.17.1.05-.05.04.04-.04.05-.05-.05v.01Z"
                    />
                    <path
                        fill="#8CBEBF"
                        d="m7.7 9.53.02-.02.05.02-.05.05-.02-.05Z"
                    />
                    <path
                        fill="#04534E"
                        d="m7.94 9.6.02-.04.03.02-.03.05-.02-.03Zm.1-.1.04-.02.03.05-.05.03-.03-.05.01-.01Z"
                    />
                    <path
                        fill="#8CBEBF"
                        d="m7.8 9.31-.03.03-.03-.03.03-.02.02.02h.01Zm-.08.08-.05.02-.02-.02.02-.03.05.03Zm.02.14-.02.03-.02-.03.02-.02.02.02Zm.15-.05-.05.03v-.05l.03-.02.02.04Zm.22.05h-.03l-.05-.02.05-.03.03.05Zm-.12.05-.03.05-.02-.05.02-.02.03.02Z"
                    />
                    <path
                        fill="#231F20"
                        d="m8.01 9.5.05-.02.02.03h-.07V9.5Zm-.12.1.02-.02.05.02h-.07Zm-.1-.19.08.05v.02h-.03l-.05-.07Zm-.12.07.05.03v.02H7.7l-.05-.05h.02Zm-.02.08.05-.03h.02l-.02.03h-.05Zm-.03-.2h.05v.03h-.02l-.03-.03Zm.1-.12.05.05v.02h-.03l-.02-.07Z"
                    />
                    <path
                        fill="#04534E"
                        d="M8.2 9.56s-.07.1-.29.07c-.21-.03-.36-.1-.4-.2v.05l.04.08.15.07.17.02.12.03.12-.03.1-.05v-.04H8.2Zm.05-.1-.1-.07-.21-.17.14.07.1.07.07.1Z"
                    />
                    <path
                        fill="#231F20"
                        d="m8.25 9.29.05.02.03.03s0 .05-.03.02l-.02-.02-.03-.05Zm.15-.07.07.05v.02l-.05-.02-.02-.05Zm.05-.03.04.05.03.05-.05-.02-.02-.08Zm.26.08.03.04v.05l-.03-.05v-.04Zm.05.02.05.05-.03.02-.02-.02v-.05Zm-.43.56h.02l.05-.05h-.05v.02l-.02.03Zm.24.07.05-.05c.02-.02.04-.02.02-.05-.02-.02-.05 0-.05.03l-.02.07Zm.2 0 .04-.05.02-.02h-.02l-.03.02-.02.05h.01Zm.06 0 .03-.05v-.05l-.03.03v.07Z"
                    />
                    <path
                        fill="#8CBEBF"
                        d="M8.2 9.58c0-.1.13-.29.3-.29l.26.07c.1.03.12.08.17.1h.15l.16-.02-.14.21-.05.05s-.05.07-.17.12a.98.98 0 0 1-.46 0c-.1-.02-.22-.12-.22-.24Z"
                    />
                    <mask
                        id="v"
                        width="2"
                        height="1"
                        x="8"
                        y="9"
                        maskUnits="userSpaceOnUse"
                    >
                        <path
                            fill="#04534E"
                            d="M8.2 9.58c0-.1.13-.29.3-.29l.26.07c.1.03.12.08.17.1h.15l.16-.02-.14.21-.05.05s-.05.07-.17.12a.98.98 0 0 1-.46 0c-.1-.02-.22-.12-.22-.24Z"
                        />
                    </mask>
                    <g mask="url(#v)">
                        <path
                            fill="#04534E"
                            d="m8.5 9.29.18-.68-.1-.02H8.5v.7Zm.26.07-.18.68h.01l.17-.68Zm.17.1-.31.63.14.07h.17v-.7Zm.15 0v.7h.09l-.1-.7h.01Zm.16-.02.59.38.87-1.3-1.55.22.1.7h-.01Zm-.14.21.5.5.04-.05.04-.06-.58-.39Zm-.05.05-.5-.5-.04.05-.04.06.58.4V9.7Zm-.14-.12a.5.5 0 0 1-.04.2.42.42 0 0 1-.38.21V8.6a1 1 0 0 0-.74.35c-.11.14-.25.37-.25.64h1.4l.01-.01Zm-.6.39.27.07.37-1.35-.27-.08-.37 1.36Zm.28.07a.41.41 0 0 1-.15-.07l.18.12.62-1.26.09.06v-.01a1.27 1.27 0 0 0-.4-.2l-.34 1.36Zm.34.12h.15v-1.4h-.15v1.4Zm.24 0 .17-.03-.2-1.39-.16.03.2 1.38-.01.01Zm-.5-1.11-.15.21 1.16.78.15-.22-1.17-.77h.01Zm-.07.1-.04.06.99.99.05-.05-1-1Zm.45.55-.58-.39a.4.4 0 0 1 .04-.05.4.4 0 0 1 .11-.09l.52 1.3c.2-.08.36-.2.49-.37l-.58-.4Zm-.43-.53a.4.4 0 0 1 .08-.02h-.11l-.34 1.35c.1.03.24.05.37.05.1 0 .32 0 .52-.08l-.52-1.3Zm-.03-.03c.08.02.14.06.18.1.05.05.14.16.14.34H7.5c0 .3.14.53.27.65.13.13.3.23.47.27l.34-1.36h.01Z"
                        />
                    </g>
                    <path
                        fill="#04534E"
                        d="M8.2 9.58h.03v-.07l.12-.15c.05-.05.07-.07.12-.07h.02l.13.02.14.05.1.05.07.05h.15l.14-.02-.12.19-.05.05c0 .02-.05.1-.17.14l-.17.03-.29-.03-.14-.1c-.05-.04-.05-.1-.05-.14H8.2c0 .07.03.12.08.17l.14.07.3.05.16-.02c.12-.05.17-.15.17-.15l.05-.05.17-.24-.22.03a.6.6 0 0 1-.12 0l-.07-.03-.1-.05-.14-.07-.13-.02h-.02l-.1.04-.12.13-.05.14Z"
                    />
                    <path
                        fill="#0C8489"
                        d="m9.1 9.6-.05.03c-.02 0-.43-.27-.56-.24-.12.02-.24.05-.26.19 0 .12.05.12.07.17.03.05.27.1.27.1h.17l.12-.03.1-.05.07-.04.02-.05.05-.08Z"
                    />
                    <path
                        fill="#04534E"
                        d="m8.45 9.53-.03.05-.05-.02.05-.05.03.02Zm.04-.1.05-.04.05.05-.05.02-.05-.02v-.01Zm.25.05.04-.02.03.02-.03.05-.04-.05Zm.04.17.05-.05.05.03-.05.05-.05-.03Zm-.12.1.05-.05.05.05-.05.02-.05-.02Zm-.21-.05.02-.02a.04.04 0 0 1 0 .07.03.03 0 0 1-.05-.02.03.03 0 0 1 .03-.03Z"
                    />
                    <path
                        fill="#8CBEBF"
                        d="m8.45 9.53-.03.05-.05-.05.05-.02.03.02Zm.12-.12-.03.05-.05-.05.05-.02.03.02Zm.24.07-.03.03-.04-.03.04-.02.03.02Z"
                    />
                    <path
                        fill="#04534E"
                        d="m8.69 9.58-.05.05-.02-.05c0-.05 0-.02.02-.02l.05.02Z"
                    />
                    <path
                        fill="#8CBEBF"
                        d="m8.52 9.7-.05.03-.05-.03.05-.05.05.05Zm.14-.12-.02.05-.05-.05.05-.05.02.05Zm.22.05-.05.05-.04-.05.02-.03.07.03Zm-.14.1-.03.04-.05-.04.05-.03.03.03Z"
                    />
                    <path
                        fill="#231F20"
                        d="M8.76 9.6h.07v.05h-.02l-.05-.05Zm-.07-.19.07.03.02.04h-.04l-.05-.07Zm-.12.1.05.05.02.04-.05-.02-.02-.07Zm-.03.05.08.02h.02l-.02.02-.05-.02-.03-.02Zm-.07-.2.07.03v.05l-.02-.03-.05-.05Zm-.14.1.07.05v.05l-.03-.05-.04-.05Z"
                    />
                    <path
                        fill="#231F20"
                        d="M8.33 9.53h.1l-.06.03-.04-.03Zm.31.22.05-.02.02.02h-.07Zm-.22-.05.03-.02.02.02-.02.03-.03-.03Z"
                    />
                    <path
                        fill="#04534E"
                        d="m9.05 9.68-.14.1-.27.04a.43.43 0 0 1-.27-.07l-.14-.12v.05l.07.1.1.02.12.05h.34l.07-.05.05-.03.02-.02.05-.07Zm-.12-.22-.1-.05c-.07-.02-.17-.1-.34-.1a.22.22 0 0 0-.21.13l.07-.1.07-.05h.12l.08.02.07.03.07.02.07.03.08.05.02.02Zm.22.05H9v.02l-.05-.07h.15l.07.02-.02.03Z"
                    />
                    <path
                        fill="#0C8489"
                        d="m8.98 10.19.05.02h.19l.05-.05.02-.12.03-.05.12-.07.12-.03h.07l.07-.04.08-.03.05-.05.02-.07-.02-.1-.1-.1-.12-.04h-.1l-.12.05-.2.05s-.11.04-.16.14c-.05.07-.05.1-.05.22v.27Z"
                    />
                    <mask
                        id="w"
                        width="2"
                        height="2"
                        x="8"
                        y="9"
                        maskUnits="userSpaceOnUse"
                    >
                        <path
                            fill="#04534E"
                            d="m8.98 10.19.05.02h.19l.05-.05.02-.12.03-.05.12-.07.12-.03h.07l.07-.04.08-.03.05-.05.02-.07-.02-.1-.1-.1-.12-.04h-.1l-.12.05-.2.05s-.11.04-.16.14c-.05.07-.05.1-.05.22v.27Z"
                        />
                    </mask>
                    <g mask="url(#w)">
                        <path
                            fill="#04534E"
                            d="M8.98 10.19h-.7v.43l.39.2.3-.63h.01Zm.05.02-.32.63.15.07h.17v-.7Zm.19 0v.7h.3l.2-.2-.5-.5Zm.05-.05.5.5.14-.15.05-.21-.7-.14h.01Zm.02-.12-.62-.31-.05.08-.01.1.68.13Zm.03-.05-.36-.6-.18.1-.09.19.63.31Zm.12-.07-.14-.69-.12.03-.1.06.36.6Zm.12-.03v-.7h-.07l-.07.02.14.68Zm.07 0v.7h.21l.18-.11-.39-.59Zm.07-.04-.22-.67-.09.03-.07.05.38.59Zm.08-.03.22.67.16-.06.11-.11-.5-.5h.01Zm.05-.05.5.5.1-.12.06-.15-.66-.23Zm.02-.07.66.22.07-.2-.05-.19-.68.17Zm-.02-.1.68-.17-.05-.18-.14-.14-.5.5.01-.01Zm-.1-.1.5-.49-.1-.1-.14-.05-.26.65V9.5Zm-.12-.04.26-.65-.13-.05h-.13v.7Zm-.1 0v-.7h-.13l-.13.05.26.65Zm-.12.05.17.68.05-.01.04-.02-.26-.65Zm-.2.05-.16-.68h-.05l-.04.03.26.65h-.01Zm-.16.14.58.39.02-.04.02-.04-.62-.3V9.7Zm-.36 1.11.04.03.63-1.26-.05-.02-.62 1.25Zm.36.1h.19v-1.4h-.2v1.4h.01Zm.69-.2.04-.05-.99-1-.05.05 1 1Zm.24-.41.02-.12-1.37-.28-.03.12 1.38.28Zm-.04.05.02-.04-1.25-.63-.02.05 1.25.62Zm-.24.24.12-.07-.72-1.2-.12.07.72 1.2Zm-.1.02.12-.03-.28-1.37-.12.02.28 1.38Zm-.02-.01h.07V9.2h-.07v1.4Zm.46-.12.07-.05-.77-1.17-.08.05.78 1.17Zm-.1.03.08-.02-.44-1.33-.08.02.45 1.33h-.01Zm.35-.2.05-.04-.99-1-.05.06 1 .99-.01-.01Zm.22-.31.02-.08-1.33-.44-.02.07 1.33.45Zm.04-.47-.02-.1-1.36.34.02.1 1.36-.34Zm-.2-.42-.1-.1-1 1 .1.09 1-1v.01Zm-.34-.25-.12-.05-.52 1.3.12.05.52-1.3Zm-.38-.1h-.1v1.4h.1v-1.4Zm-.36.05-.12.05.52 1.3.12-.05-.52-1.3Zm-.03.02-.2.05.35 1.36.19-.05-.34-1.36Zm-.02.73a127.69 127.69 0 0 0-.28-.65.9.9 0 0 0-.18.1 1 1 0 0 0-.34.38l1.25.62c-.05.11-.12.16-.13.17l-.03.01h-.01l-.01.01h-.01l-.26-.64Zm-.76-.25a.93.93 0 0 0-.14.34c-.03.12-.02.24-.02.27h1.4v-.05.06l-.05.12-.02.04-1.17-.78Zm-.16.6v.28h1.4v-.27h-1.4v-.01Z"
                        />
                    </g>
                    <path
                        fill="#8CBEBF"
                        d="M9.03 10.14c.05 0 .02-.08.07-.15l.1-.17.02.03.05-.05s0-.05.05-.07l.1-.08h.04v.03h.05v-.05h.07l.05.02v.05l.05.03c.05 0 .02-.03.02-.03h.03v-.05c.02 0 .05.08.07.05v-.07l-.07-.1-.12-.05-.15.03-.14.07-.12.07s-.03.1-.05.1l-.05-.07-.05.14c0 .05-.07.17-.05.22l.03.1Z"
                    />
                    <path
                        fill="#8CBEBF"
                        d="m9.17 9.97-.02.02-.03.03.03.02h.07v-.07h-.05Zm.22-.2-.02.03.02.05h.05v-.03l-.03-.05h-.02Zm.2.05-.03-.02-.03.05.05.02v-.05h.01Zm-.54.03.05.04.05-.04-.05.02h-.02l-.03-.02Z"
                    />
                    <path
                        fill="#04534E"
                        d="M9.22 10v.04h-.07l-.03-.02.05.02.05-.05V10Zm.5-.3-.02.03-.04.02-.03-.02v-.05s0 .05.05.05.05-.03.05-.03h-.01Zm-.45.1-.05.05c-.05 0-.02 0-.02-.03h.04l.03-.02Zm.1 0v.05h.07v-.03a.02.02 0 0 1-.03.03l-.04-.03V9.8Zm-.34.4c0 .01.19.01.19-.01 0-.03 0-.15.12-.22s.2-.07.27-.1c.07-.02.2-.05.22-.17.02-.07-.1-.07-.13-.14-.02-.08-.14-.03-.14-.03s-.1-.02-.17.03l-.02.1-.17.02v.07l-.05-.02.02-.13.17-.1.17-.09h.15l.12.07.07.08v.17c-.02.1-.15.17-.24.17-.1 0-.22.07-.27.1-.05.02-.07.19-.07.21h-.24v-.01Z"
                    />
                    <path
                        fill="#231F20"
                        d="M9.1 9.82h-.02v-.07.05l.02.02Zm.12-.02v-.05l.07-.05-.02.05-.05.05Zm-.05.2v-.03l.03-.08v.1h-.03V10Z"
                    />
                    <path
                        fill="#231F20"
                        d="m9.27 9.94-.05.03c0 .02-.02.05-.05.02l.03-.02.07-.03Zm.17-.24-.05.05v.05l.02-.03.03-.07Zm.05.1-.03-.03h-.05l-.02.03h.1Zm-.03-.17.03-.03.02-.04-.02.02-.03.05Zm.24 0-.02.02-.02.05.02-.02.02-.05Zm-.07.17-.02.02-.05.03v-.03l.05-.02h.02Z"
                    />
                    <path
                        fill="#FCCA3E"
                        d="M8.03 8.95 8 9.1h.04l.03-.15h-.04Z"
                    />
                    <mask
                        id="x"
                        width="1"
                        height="2"
                        x="8"
                        y="8"
                        maskUnits="userSpaceOnUse"
                    >
                        <path
                            fill="#AA8C30"
                            d="M8.03 8.95 8 9.1h.04l.03-.15h-.04Z"
                        />
                    </mask>
                    <g mask="url(#x)">
                        <path
                            fill="#AA8C30"
                            d="M8.03 8.95v-.4h-.29l-.1.27.4.13h-.01ZM8 9.1l-.4-.13-.17.54H8V9.1Zm.04 0v.4h.35l.06-.34-.4-.06h-.01Zm.03-.15.4.07.08-.48h-.48v.41Zm-.41-.13-.05.15.77.26.05-.15-.77-.26Zm.34.69h.04v-.82H8v.82Zm.45-.35.02-.14-.8-.14-.03.15.8.13h.01Zm-.38-.62h-.03v.82h.03v-.82Z"
                        />
                    </g>
                    <path
                        fill="#FCCA3E"
                        d="m8.06 8.88-.03.02.03.05.05-.02-.05-.05Z"
                    />
                    <mask
                        id="y"
                        width="1"
                        height="1"
                        x="8"
                        y="8"
                        maskUnits="userSpaceOnUse"
                    >
                        <path
                            fill="#AA8C30"
                            d="m8.06 8.88-.03.02.03.05.05-.02-.05-.05Z"
                        />
                    </mask>
                    <g mask="url(#y)">
                        <path
                            fill="#AA8C30"
                            d="m8.06 8.88.25-.25-.25-.25-.25.25.25.25Zm-.03.02-.24-.24-.18.17.11.23.31-.16Zm.03.05-.31.16.15.31.32-.16-.16-.3v-.01Zm.05-.02.15.31.44-.22-.35-.34-.24.25Zm-.3-.3-.02.03.5.5.02-.03-.5-.5Zm-.09.43.03.05.62-.32-.02-.04-.63.31Zm.5.2.04-.02-.3-.63-.06.03.32.62Zm.13-.58-.04-.05-.5.5.05.04.5-.49h-.01Z"
                        />
                    </g>
                    <path
                        fill="#FCCA3E"
                        d="m6.83 8.42.1.2.02-.06-.1-.14h-.02Z"
                    />
                    <mask
                        id="z"
                        width="1"
                        height="1"
                        x="6"
                        y="8"
                        maskUnits="userSpaceOnUse"
                    >
                        <path
                            fill="#AA8C30"
                            d="m6.83 8.42.1.2.02-.06-.1-.14h-.02Z"
                        />
                    </mask>
                    <g mask="url(#z)">
                        <path
                            fill="#AA8C30"
                            d="M6.83 8.42V8h-.67l.3.6.37-.2v.02Zm.1.2-.37.18.36.73.37-.73-.37-.19.01.01Zm.02-.06.36.19.1-.22-.12-.2-.34.23Zm-.1-.14.34-.23-.12-.18h-.22v.41Zm-.4.18.1.2.74-.37-.1-.2-.73.37h-.01Zm.84.2.02-.05-.73-.37-.02.05.73.37Zm0-.46-.1-.15-.68.46.1.14.68-.45ZM6.85 8h-.02v.82h.02V8Z"
                        />
                    </g>
                    <path fill="#FCCA3E" d="M6.8 8.35v.07h.07v-.07H6.8Z" />
                    <mask
                        id="A"
                        width="1"
                        height="1"
                        x="6"
                        y="8"
                        maskUnits="userSpaceOnUse"
                    >
                        <path fill="#AA8C30" d="M6.8 8.35v.07h.07v-.07H6.8Z" />
                    </mask>
                    <g mask="url(#A)">
                        <path
                            fill="#AA8C30"
                            d="M6.8 8.35V8h-.35v.35h.35Zm0 .07h-.35v.35h.35v-.35Zm.07 0v.35h.35v-.35h-.35Zm0-.07h.35V8h-.35v.35Zm-.42 0v.07h.7v-.07h-.7Zm.35.42h.07v-.7H6.8v.7Zm.42-.35v-.07h-.7v.07h.7ZM6.87 8H6.8v.7h.07V8Z"
                        />
                    </g>
                    <path
                        fill="url(#B)"
                        d="M7.96 9.39c.05 0 .11-.06.13-.15 0-.08-.03-.16-.09-.17-.05 0-.11.05-.12.14-.02.09.02.17.08.18Z"
                    />
                    <path
                        fill="#AA8C30"
                        d="m8.08 8.88-.05.05.03.02h-.03l-.02-.02.02-.03v-.02h.05Zm-.02.1L8.03 9l-.02.05.02-.1h.03v.03Zm-1.23-.63c0 .02-.05.05-.03.07.03.02.05 0 .07 0l-.02.02h-.02l-.03-.02-.02-.02v-.03l.02-.02h.03Z"
                    />
                    <path
                        fill="#AA8C30"
                        d="M6.87 8.44v.1l-.04-.1.02-.02.02.02Z"
                    />
                    <path
                        fill="url(#C)"
                        d="M6.92 8.82c.04.09.12.13.18.1.05-.03.07-.12.02-.2-.04-.09-.12-.13-.18-.1s-.07.12-.02.2Z"
                    />
                    <path
                        fill="#E92736"
                        d="m8.1 9.15.06-.05-.03-.03h.03l-.05-.05v.03h-.03l-.02.02v.05l.02.03h.03-.01Z"
                    />
                    <path
                        fill="#E92736"
                        d="M7.99 9.05v.02L8 9.1h.05l.02-.05v-.03L8.01 9 8 9.05h-.01Zm-.1.02.02.03h.05L8 9.05 7.96 9H7.9l.02.02-.02.03v.02h-.01Zm-1.06-.34h.04l.03-.02.02-.05-.05-.05h-.02l-.02-.02-.05.07h.02v.05l.03.02Z"
                    />
                    <path
                        fill="#E92736"
                        d="m6.87 8.61.03.05h.05l.04-.05-.02-.02v-.05h-.02v-.02l-.1.04h.02v.05Z"
                    />
                    <path
                        fill="#E92736"
                        d="M7.07 8.59v-.05l-.03-.02v-.03c0-.02-.1 0-.07.03.02.02 0 .02 0 .02v.07h.07l.03-.02Z"
                    />
                    <path
                        fill="#F7E204"
                        d="M7.96 9.07h-.02l-.03-.02v-.03l.05.03v.02ZM8 9.05v.05l.05-.03-.03-.02H8Zm.08.02v.05h.05V9.1l-.05-.03Zm-1.21-.41v.05l-.04-.02v-.03l.02-.02.02.02Zm.03-.07v.05h.05l.02-.08h-.02l-.05.03Zm.1-.05v.05h.04v-.05H7Z"
                    />
                    <path
                        fill="#FCCA3E"
                        d="m10.82 9.23-.12.17-.04-.06.13-.12h.03v.01Z"
                    />
                    <mask
                        id="D"
                        width="1"
                        height="1"
                        x="10"
                        y="9"
                        maskUnits="userSpaceOnUse"
                    >
                        <path
                            fill="#AA8C30"
                            d="m10.82 9.23-.12.17-.04-.06.13-.12h.03v.01Z"
                        />
                    </mask>
                    <g mask="url(#D)">
                        <path
                            fill="#AA8C30"
                            d="m10.82 9.23.1-.4.57.15-.34.48-.33-.23Zm-.12.17.33.23-.36.52-.32-.55.35-.2Zm-.04-.06-.35.2-.17-.28.25-.23.27.3v.01Zm.13-.12-.27-.3.16-.15.22.05-.1.4h-.01Zm.36.24-.12.17-.67-.47.12-.17.67.47Zm-.8.14-.04-.06.7-.41.04.06-.7.41Zm.04-.57.13-.11.55.6-.13.12-.55-.6v-.01Zm.5-.2h.03l-.2.8-.03-.01.2-.8v.01Z"
                        />
                    </g>
                    <path
                        fill="#FCCA3E"
                        d="m10.87 9.16-.01.07-.07-.01.01-.07.07.01Z"
                    />
                    <mask
                        id="E"
                        width="1"
                        height="1"
                        x="10"
                        y="9"
                        maskUnits="userSpaceOnUse"
                    >
                        <path
                            fill="#AA8C30"
                            d="m10.87 9.16-.01.07-.07-.01.01-.07.07.01Z"
                        />
                    </mask>
                    <g mask="url(#E)">
                        <path
                            fill="#AA8C30"
                            d="m10.87 9.16.1-.34.33.1-.09.33-.34-.09Zm-.01.07.33.1-.08.33-.34-.09.09-.34Zm-.07-.01-.1.33-.33-.08.09-.34.34.09Zm.01-.07-.34-.1.1-.33.33.09-.09.34Zm.41.1-.02.07-.67-.17.01-.07.68.17Zm-.44.32-.07-.02.17-.67.07.01-.17.68Zm-.32-.44.01-.07.68.17-.02.07-.67-.17Zm.44-.32.07.01-.17.68-.07-.02.17-.67Z"
                        />
                    </g>
                    <path
                        fill="url(#F)"
                        d="M10.65 9.6c-.07.07-.16.09-.2.05-.05-.05-.04-.14.02-.2.06-.08.15-.1.2-.06.05.04.04.13-.02.2v.01Z"
                    />
                    <path
                        fill="#E92736"
                        d="m10.75 9.53-.04-.01-.02-.03-.01-.05.06-.04h.05l.03.07h-.02l-.02.04-.03.02Z"
                    />
                    <path
                        fill="#E92736"
                        d="m10.74 9.4-.04.04h-.05l-.03-.07.03-.01.01-.05h.02l.01-.02.08.07h-.02l-.01.04Z"
                    />
                    <path
                        fill="#E92736"
                        d="M10.56 9.33v-.05l.04-.01v-.03c0-.02.1.03.07.05-.03.01 0 .02 0 .02l-.03.07-.07-.02-.01-.03Z"
                    />
                    <path
                        fill="#F7E204"
                        d="M10.72 9.45v.05l.05-.01v-.03l-.02-.03-.03.02Zm0-.08-.01.05-.05-.01v-.08h.02l.04.04Zm-.08-.07-.01.05-.05-.01.01-.05.05.01Z"
                    />
                    <path
                        fill="#AA8C30"
                        d="M10.85 9.16c0 .02.03.06 0 .07-.02.02-.04 0-.06-.01l.01.02.03.01.03-.02.02-.01.01-.03-.02-.03h-.02Z"
                    />
                    <path
                        fill="#AA8C30"
                        d="m10.78 9.24-.02.1.07-.09-.02-.03-.03.02Z"
                    />
                    <path
                        fill="#A8AC71"
                        d="M7.68 7.17h-.22c-.09-.03-.09-.26-.09-.28 0-.03-.06-.06-.06-.12 0-.05.2-.2.23-.22l.06.03.05-.06.03.03-.08.08-.03.09-.06.08c-.03.03 0 .06.03.06l.11-.03.09-.06-.09.12-.1.02S7.47 7 7.6 7l.14-.03-.06.2Zm-.56.6s.08.02.08.1c0 .1-.08.18-.08.32s.03.14.22.3c0 0 .06.04.06.1 0 .05.06.3.23.3s.22-.11.22-.11l-.08-.11h-.12l-.08-.06-.06-.2c-.05-.11-.2-.14-.2-.28s.09-.11.06-.28c-.03-.17-.2-.2-.2-.2l-.08-.03-.03.14h.06v.01Z"
                    />
                    <path
                        fill="#F1A720"
                        d="M7.65 6.75c.06-.03.03-.17.03-.17l-.05.02.02.06v.09Z"
                    />
                    <path
                        fill="#A8AC71"
                        d="M7.77 8.36h-.03c-.03-.03-.14-.12-.11-.34.02-.29.4-.4.42-.51.03-.11.11-.17-.2-.43l-.05.09.1.11s.04-.03.04 0l-.03.12-.23.16-.11.09-.09.14-.02.26s0 .28.3.3l.01.01Z"
                    />
                    <path
                        fill="#78732E"
                        d="m7.57 8.53.03.08-.06.03h-.06l-.05.06v-.03L7.4 8.6l.06.03h.05v-.06l.06-.05v.01Zm-.17 0-.03-.03-.06-.03.06-.03h.06l-.03.06v.03Zm.08-.15.06.03v.06l-.06-.03h-.05l.03-.06h.02Zm-.02.43v-.03l-.03-.06h.05l.06.03v.03l-.06.03h-.02Zm.2-.14-.06-.03V8.6l-.03.06v.05h.06l.02-.02v-.03l.01.01Zm-.18.17.06.03.03.02.03-.02.03-.06-.12.03h-.03Zm.17-.03.09-.06v-.08h-.06l-.03.08v.06Zm-.08.08s.08.03.2-.02l.05-.03-.05-.03-.03.06-.17.02Zm-.09-.76-.02-.03v-.05l.02.02.06.03-.03.03h-.03Zm.09.14-.03-.03-.03-.05.03.03h.06l-.03.05Z"
                    />
                    <path
                        fill="#C6C7A6"
                        d="M7.34 6.72c0 .03-.03.08.03.08 0 0 .09 0 .17-.08l.03-.12.03-.02h-.1l-.17.14h.01Z"
                    />
                    <path
                        fill="#1C242F"
                        d="M7.56 6.6a.01.01 0 0 0 .01-.01.01.01 0 0 0-.01-.01.01.01 0 0 0 0 .03V6.6Z"
                    />
                    <path
                        fill="#A8AC71"
                        d="m7.46 6.6-.06.06s.06 0 .08-.06h.12v-.02h-.06l-.08.02Z"
                    />
                    <path
                        fill="#78732E"
                        d="M7.63 8.1v-.08l-.03.03-.03.05.03.03.03-.03Zm-.17-.08v-.09l.02-.11v.06l.06.08h.03l-.06.06h-.05Zm.17-.03v-.03l.02-.06-.05.06h-.03l.03.03h.03Zm-.15-.23.03-.05.06-.06.03.08v.09h.03l-.03.03-.09-.03-.03-.06Zm.17.12.03-.03.06-.03h-.11v.06h.02Zm-.05-.26.03-.03.05-.03.03.15-.08-.03-.03-.06Zm.14.17.08-.06-.14-.02.03.08h.03Zm.06-.17v-.14l-.06.06-.03.02.06.03.03.03Zm.1-.14V7.4h-.02l-.03.02-.03.03.03.03h.06-.01Zm.04.14.05-.06.06-.05h-.14v.05l.03.06Zm-.34-.5-.03.05h.14l-.03-.03-.05-.03-.03-.03v.04Zm.22.59.06-.03.06-.06h-.12v.09Zm.26-.23v-.14l-.12.06.03.02.03.06h.06Z"
                    />
                    <path
                        fill="#78732E"
                        d="m7.9 7.37.04-.03V7.3h.11l-.03.06L8 7.4h-.05l-.03-.03H7.9Zm.15-.06-.03-.08-.06-.03-.02.08v.03h.11Z"
                    />
                    <path
                        fill="#fff"
                        d="m7.17 8.02-.02.03.08-.03.08.05v-.02l-.08-.06-.06.03Zm0-.2h.03l.06-.06h.05l-.02-.03h-.06l-.06.09Zm.17.14L7.3 7.9c-.03-.02-.09.03-.09.03v.03l.09-.03c.05 0 .05.09.05.09v-.06h-.01Zm-.17-.17.03-.06.03-.05H7.2l-.03.03v.08Zm-.02-.08.02-.06-.05.03v.08h.03v-.05ZM7.43 7l.05-.03-.02.11-.03.09h.03l.02-.06.06.06h.03l.03-.09v-.02L7.68 7h-.03l-.05.06A.34.34 0 0 1 7.57 7h-.03l-.06.06.03-.09v-.03l-.08.03-.06.06v.03L7.43 7Zm.05.06L7.57 7l.03.08-.03.09-.09-.09v-.02Zm-.28.79v.03l.09-.03.08.03v-.03l-.08-.03-.09.03Zm.8-.43V7.4a.45.45 0 0 0 .08-.06l-.03-.03h-.11l.02-.08L8 7.2l-.03-.03-.02.03-.12-.03.09.03a.06.06 0 0 0 .05 0l-.02.05v.06h.11L8 7.37h-.03l-.02-.06v.03l.02.06-.05-.03-.03.03v.08a1 1 0 0 1-.06-.03v.03H7.8v.11l-.09-.03h-.03v.12c-.05 0-.08-.06-.08-.06l-.03.03.03.17h-.03c-.06 0-.09-.06-.09-.06v.06s0 .08.06.14h.03l-.11.06v.03l.08.05-.06.03v.03l.06-.06.09.03V8.1h-.06l.06-.08v-.03l-.06-.03.08-.06v-.02l-.02-.03.1-.03v-.03l-.02-.08.11.02v-.1h.12L7.9 7.5h.14l.03-.03-.09-.06.02.01Zm-.4.6-.03.05-.03.03v-.03l-.06-.02.09-.06.03.03Zm.05-.12-.08.06v-.03c-.06-.03-.09-.05-.09-.11l.09.03h.03l.05.05Zm.06-.1-.08.02-.03-.17.08.06.03.08v.01Zm0-.12v-.09l.09.03v.09l-.09-.03Zm.2-.09-.09.03v-.14l.09.03v.08Zm0-.11V7.4h.05l.03.05.03.03h-.11Zm-.28.7v-.02l-.03.05h-.03L7.5 8.2l.06.02v.09l.03-.09.03.03v.09h.08l-.03-.03h-.05v-.03l.02-.03-.02-.03H7.6s.01-.02.03-.02v-.02Zm-.43-.05.09.03v-.03l-.06-.03-.11.03v.06l.08-.06Zm.51.73H7.6l.03-.05c.1-.03.1-.09.1-.09V8.7l-.08.08.03-.11h-.03l-.08.05.03-.08V8.6l-.09.03.06-.11V8.5l-.09.11v.03l-.08-.06v.03l.08.03-.05.06v.02l.11.03-.08.06.02.03.15-.03-.06.08.14-.03.09-.05-.03-.03-.06.08Zm-.25-.16.02-.06h.09l-.03.08-.08-.02Zm.05.1.03-.05h.03c.06 0 .08-.05.08-.05l-.02.1H7.5h.01Zm-.08-.36.14.03-.03-.03h-.11l.08-.08h-.03l-.05.05v.03H7.3l.03.03.06-.03v.11l.03-.1.01-.01Zm-.12-.23V8.2h-.1c-.06 0-.06.08-.06.08v.03l.08-.06.08-.03v-.01Zm.12.09H7.4l-.09.03-.02.08.02.03.03-.08.09-.06Zm-.14 0 .08-.03-.03-.03-.08.03-.09.09.06.02.06-.08Zm.2-1.67.05-.03h.03l-.03.09-.03.06-.05.1.02.06.03-.02h-.03v-.03l.03-.09.06-.08V6.6l-.03-.02-.08.05-.06.03.08-.03h.01Z"
                    />
                    <path
                        fill="#78732E"
                        d="M7.65 7h-.08l.03.06.05-.06Zm-.1 0v-.03H7.5L7.48 7v.06L7.54 7h.01Zm0 .17-.07-.09-.05.09h.12Zm.27 1.67c-.02.02-.08.05-.2.05a.25.25 0 0 1-.1-.03l-.06-.08-.03-.14-.06-.14-.14-.12c-.06-.05-.08-.08-.08-.2l-.03-.02.05-.17.03-.11v-.03l-.05-.06-.03-.03-.03-.03-.03.03h.06l.03.03.05.06v.03l-.03.1-.05.18v.03c0 .11.05.17.11.22l.14.12.06.17.03.1.05.06.12.03c.1 0 .2-.05.2-.05h-.01Zm-.14-.17-.05-.03-.06-.09-.03-.1-.11-.15c-.06-.06-.12-.09-.12-.14l.03-.14.03-.14v-.03c0-.06-.06-.12-.11-.17a.5.5 0 0 0-.11-.06v.03l.1.06.12.14v.03l-.06.14-.02.14v.03l.11.11.14.14.03.11.06.09.05.03Z"
                    />
                    <path
                        fill="#A8AC71"
                        d="M8.08 8.38s.05 0 .05.06l-.02.11-.09-.05.06-.06v-.06Z"
                    />
                    <path
                        fill="#AF7029"
                        d="m8 8.36-.1-.09-.08-.11-.08-.03-.06-.08v-.17l.03-.06s-.17.06-.08.4c.05.14.14.16.14.16l.17-.02H8Z"
                    />
                    <path
                        fill="#816C2A"
                        d="M7.94 7.28v.03c-.06.14-.17.2-.29.25-.05.06-.1.09-.14.17l-.05.23V8c0 .17.05.28.14.34.08.05.17.05.2.05h.05l.11-.02.09.02h.03a.03.03 0 0 1 0 .03l-.03.03-.03.03v.03l.06-.03.03-.06a.03.03 0 0 0-.03-.03l-.03-.02H7.8l.02.02v-.02H7.8c-.03 0-.12 0-.2-.06-.06-.03-.14-.14-.14-.31v-.03l.05-.23.23-.2c.08-.05.17-.1.2-.22v-.04Z"
                    />
                    <path
                        fill="#fff"
                        d="m8.13 8.41-.05.09.05.03h-.02l-.06-.03v-.03l.03-.03.03-.06.02.03Z"
                    />
                    <path
                        fill="#FCCA3D"
                        d="m8.28 8.47-.09.03-.06-.03-.02-.09-.06-.02h-.09l-.16-.2h.16l.09-.03.06.03h.05l.03.03.03.02.06.06v.2Zm-.12-1.19v-.05l-.03-.06-.02-.06-.06-.05-.03-.03h-.11l-.06.05s.14.12.2.23l.11.06v-.09Z"
                    />
                    <path
                        fill="#AF7029"
                        d="m8.08 7.4-.03.14.06-.09.05-.08-.11-.06.03.09Z"
                    />
                    <path
                        fill="#6F5B24"
                        d="m8.28 8.53-.03.05-.09.06.09.03.08-.06-.05-.08Z"
                    />
                    <path
                        fill="#404118"
                        d="m8.3 8.61-.02.03h-.03l.03-.09.02.03v.03Z"
                    />
                    <path
                        fill="#AB6D29"
                        d="M8.9 6.12s-.26-.05-.26.17c0 .05.02.07.07.1.05.02.17.02.27.1.1.07.1.14.1.19l-.03.1.07.28.05.22.17-.1.12-.3-.14-.59-.41-.17H8.9Z"
                    />
                    <mask
                        id="G"
                        width="2"
                        height="2"
                        x="8"
                        y="6"
                        maskUnits="userSpaceOnUse"
                    >
                        <path
                            fill="#4D2A15"
                            d="M8.9 6.12s-.26-.05-.26.17c0 .05.02.07.07.1.05.02.17.02.27.1.1.07.1.14.1.19l-.03.1.07.28.05.22.17-.1.12-.3-.14-.59-.41-.17H8.9Z"
                        />
                    </mask>
                    <g mask="url(#G)">
                        <path
                            fill="#4D2A15"
                            d="m8.9 6.12.2-.46-.05-.02L9 5.63l-.1.5v-.01Zm.18.56.48.12.02-.06v-.06h-.5Zm-.03.1-.48-.13-.03.12.03.13.48-.13v.01Zm.07.28.5-.1-.01-.02-.49.12Zm.05.22-.49.11.15.66.59-.33-.25-.44Zm.17-.1.25.44.15-.09.07-.16-.47-.18v-.01Zm.12-.3.47.17.06-.15-.04-.15-.49.12v.01Zm-.14-.59.48-.12-.06-.25-.23-.1-.2.47h.01Zm-.41-.17.08-.5h-.1c-.05 0-.14 0-.23.02a.66.66 0 0 0-.52.65h1a.36.36 0 0 1-.1.23.32.32 0 0 1-.16.1h-.06l.09-.5Zm-.77.17c0 .12.03.25.13.37.08.1.17.15.22.17l.45-.89.03.02a.41.41 0 0 1 .17.33h-1Zm.35.54c.05.03.1.05.16.06h.03a.8.8 0 0 1 .03.01c.02 0 0 0-.03-.02l.6-.8a.91.91 0 0 0-.38-.16h-.03c.01 0 .04 0 .07.02l-.45.9v-.01Zm.19.05a.27.27 0 0 1-.09-.12c-.02-.06-.01-.1-.01-.08h1c0-.03 0-.14-.05-.26a.73.73 0 0 0-.25-.34l-.6.8Zm-.09-.32-.02.1.97.24.02-.1-.97-.24Zm-.02.34.07.29.97-.25-.07-.29-.97.25Zm.07.27.04.22.98-.22-.05-.21-.97.21Zm.78.55.17-.1-.5-.87-.17.1.5.87Zm.39-.35.12-.32L9 6.7l-.13.32.94.36v-.01Zm.14-.62-.15-.58-.97.24.15.58.97-.24Zm-.44-.92-.41-.17-.38.92.4.17.39-.92Z"
                        />
                    </g>
                    <path
                        fill="#4D2A15"
                        d="M9.17 7.21s.07-.05.1-.12c.02-.03-.07-.1-.1-.1l.1.05.05.02c.02 0 .05-.1.02-.12l-.07-.1-.1-.02h.1l.05.03-.03-.12-.07-.08h-.1l.12-.02.05.02-.02-.1-.1-.07h-.1l.1-.02.05.02-.02-.04-.17-.08H8.9l.04-.02h.03l-.1-.05H8.8l-.12.02.02-.04h.05c.05-.03-.02-.05-.02-.05l.04-.05h.15l.29.2.15.11.1.22-.03.41-.22.17h-.07l.02-.07h.01Z"
                    />
                    <path
                        fill="#D2A567"
                        d="m8.9 6.22-.02-.07v-.03s-.1-.02-.14.05c-.05.07-.05.14-.05.14l.07-.04h.12l-.05-.05h-.07l.07-.03.08.03H8.9Z"
                    />
                    <path
                        fill="#8F4620"
                        d="m9.2 7.23-.05.03.02.26.27.46.14-.02.05-.07h.03c.02.02.07.12.12.12l.1.05.19.24-.03-.07-.02-.15-.05-.07-.02-.03h.07l.05.03.07.05.02.04.03.05.02.05v.05l.05.1.05.07v-.05l-.03-.07-.04-.24-.05-.08.07.05.07.1.03.07.02.07.03.08.02.05.02-.03v-.05l-.04-.14V8l.04.02.05.1v.14l.03.15.05.14.04.08.03.05V8.6l-.05-.58V8l.02.02.05.07.03.1v.05l.02.12v.15l.07.12.03.1.02-.1-.02-.63v-.03l.05.05.02.03.02.14.03.41.02.1.1-1.04.07-.02.03-.03-.05-.05-.12-.17-.1-.19-.15-.24-.24-.32-.2-.14-.04-.05V6.4l.05-.05h-.12l-.1-.02-.14-.12-.17-.07-.12-.05-.25-.05-.24-.03-.1-.02-.12.02-.04.05-.03.12c0 .05.03.05.1.1l.24.12.07.07.03.05v.03l.07.4-.12.23-.07.04v.01Z"
                    />
                    <path
                        fill="#AB6D29"
                        d="M9.46 7.89s.05.07.12 0c.08-.08-.05-.22-.05-.22l.05-.02.05.1v.11c0 .08-.07.12-.07.12l-.07-.02-.03-.07Z"
                    />
                    <path
                        fill="#4D2A15"
                        d="m11.01 8.85-.07-.16v-.15l-.03-.34v-.12l-.07-.07-.02-.03.02-.02.03.02-.03-.17-.14-.31h.02l.02.05.08.05.14.05.1.02.05.1.02.29c0 .1 0 .17-.05.24-.05.07-.02.39-.05.43l-.02.1v.02Z"
                    />
                    <path
                        fill="#8F4620"
                        d="m11.01 8.35.05-.08c0-.04 0-.46-.05-.5l-.14-.1.04.14.03.05.02.08.05.21v.2Z"
                    />
                    <path
                        fill="#4D2A15"
                        d="M10.8 8.61v-.34l-.03-.17a1.17 1.17 0 0 1-.1-.24l-.07-.24-.07-.05-.03.05-.05-.02-.02-.03.02-.07v-.07l.08.07.14.1.07.31.08.2.02.33-.02.3-.03-.13h.01Zm.07-.92.07.05.05.05-.08-.02a.22.22 0 0 1-.04-.03v-.05Z"
                    />
                    <path
                        fill="#4D2A15"
                        d="m10.58 8.54.02-.14-.05-.34c0-.05-.07-.05-.14-.17l-.08-.2a3.6 3.6 0 0 1-.07-.07V7.5l.15.05.04.05.08.31.05.1.02.12.05.31v.25l-.07-.15Zm-.15-.14-.02-.17-.08-.2-.14-.17-.15-.2v-.11l.08.05c.04 0 .07.05.07.05l.05.14.04.1.05.1.05.02.03.17.02.07.02.12v.07l-.02-.04Zm-.12 0-.05-.03.02-.07-.04-.15-.05-.07-.15-.17-.14-.12-.07-.02-.03-.15.1.07.07.03.1.2.05.04.1.07.02.07.04.1.03.12v.1-.02Zm-.2-.03-.07-.12-.02-.1c-.03-.05-.07-.14-.15-.17-.07-.02-.12-.12-.12-.14l.03-.05.02.05.17.17.05.1.05.1.02.06.03.05v.05h-.01Zm.59-.87s.12.15.14 0c.03-.05-.05-.17-.05-.17l-.12-.22-.22-.26-.14-.08.05.08.22.31c.12.22.1.34.1.34h.02Zm-.66-.85s.22.2.37.39c.14.22.21.36.17.39-.05.02-.13-.03-.15-.08-.05-.07-.07-.16-.22-.31l-.2-.2-.09-.14.12-.05Zm-.12.46.22.2.12.17.05.04v-.07l.02-.02-.4-.44v.12h-.01Zm-.02 0 .12.17.14.15.03.1s-.2-.15-.2-.13l.05.12-.07-.02-.07-.12-.05-.1-.05-.14.1-.03Zm-.58.46s.1.1.14 0c.05-.1.03-.17.03-.17s.12.2.17 0l-.08-.17.03-.02.07.12s.07-.05.07-.12c0-.07-.07-.2-.07-.2l.07.08s.12 0 .12-.07c0-.08-.1-.17-.1-.17s.08 0 .08-.05-.12-.1-.12-.12c0-.03.05-.1.1-.05.04.05.12.05.16-.03.05-.07-.02-.07-.02-.07H9.9l-.12-.07-.1-.05h-.1l.03.07.02.22v.1l.03.22-.05.17-.03.02-.02.02-.05.1-.05.07-.07.1-.07.07Z"
                    />
                    <path
                        fill="#AB6D29"
                        d="m10.02 7.98-.07-.12c-.05-.05-.15-.05-.15-.05l.15.17h.07Zm.22.03-.12-.15c-.08-.05-.08-.14-.1-.14h-.03v.12l.13.1.12.07Zm.17 0-.1-.22c-.05-.12-.1-.14-.1-.14v.1l.05.11.07.1.08.05Zm.14-.07s.03-.22 0-.3c-.02-.07-.12-.07-.12-.07v.2l.07.12.05.05Zm.12-.4.07.1.08.34-.15-.21-.02-.22h.02v-.01Z"
                    />
                    <path
                        fill="#D2A567"
                        d="m9.7 7.81.08-.02c0-.02-.08-.07-.08-.12l.08-.02c0-.03-.08-.13-.05-.15.02-.02.1.12.1.12l.02.12c-.05.12-.15.07-.15.07Zm.17-.14H10l-.1-.12-.02-.05h.1l-.1-.12.03-.03.1.13c.04.07.07.1.04.19 0 .1-.17.02-.17 0h-.01Zm.51-.17v-.1l.05-.02-.1-.03h-.05c-.02.03.05.08.05.08l.05.07Zm-.34.05.2.02c.02-.02-.15-.14-.15-.14V7.4h.07v.05l.08.1v-.12l.07.05.12.07.02-.07c0-.03.03.1-.02.12l-.1-.03-.02-.02-.03-.03s.03.1 0 .1h-.14l-.1-.07Zm.39-.12s.2.12.22.1c.02-.03-.05-.3-.05-.32.02-.02.14.31.1.34-.08.05-.1.02-.1.02l-.07-.05-.1-.1v.01Zm.53.46.03.02.02.03h-.05v-.05Zm-.17-.58h.03l-.03.02v-.02Zm-.07-.1.05-.02.02-.03-.05-.02-.02-.03h-.05l.05.1Zm.17.53.07.03.03.02h-.1v-.05Zm-.31-.84h.04v.04l-.04.03-.05-.07h.05Zm-.27-.25h.07l.05.03.02.14-.14-.07-.05-.1h.05Zm-.1-.05s.07 0 .07-.04a.1.1 0 0 0-.04-.08l-.12.08.1.04h-.01Zm-.24-.1h.05l.14-.11h.08v.1l-.17.07-.05-.03h-.05V6.5Zm-.05-.16-.07-.07.07.12v.14h.03l.02-.02v-.07l-.02-.05v-.03l-.03-.02Zm-.2-.07-.2-.15.18.15c.05.04.03.14.05.17.03.02.03-.03.03-.03l.02-.02-.02-.03-.03-.05V6.3l-.02-.02-.01-.01Zm-.2-.1c-.08-.07-.25-.1-.37-.1s-.2 0-.2.08c.03.07.1.1.2.1h.2l.14.06-.1-.1-.1-.04s-.02-.02.05-.02c.1.02.2.07.22.12l.02.12h.03v-.1l-.05-.07-.05-.05h.01Zm-.37 1.06c.07 0 .2-.1.2-.24 0-.14-.08-.43-.08-.48 0-.05.02 0 .05.02.02.03.1.24.1.39 0 .14-.03.2-.13.29-.1.1-.14.05-.14.05v-.03Zm.2.44.06.02c.05-.02.15-.07.15-.14 0-.05-.07-.1-.07-.12V7.4h.04l.03.1h.05c.02-.02.1-.05.07-.1l-.07-.14V7.2l.05.02.02.08h.05c.02-.03.1-.05.07-.1l-.05-.1.08-.02c.04-.03.1-.03.1-.07l-.06-.08v-.02l.03.02.05.03v.1l-.08.07-.04.02.02.05v.07l-.05.05-.07.02v.08l-.05.07-.07.05h-.03v.05l-.05.07-.1.05-.04.02-.05-.05v-.02l.01.01Z"
                    />
                    <path
                        fill="#D2A567"
                        d="M9.83 6.9s.14.02.14-.08c0-.05-.14-.17-.17-.17V6.6l.07.05s.1.03.12-.02v-.07l.03-.03.05.03-.03.07-.02.22s0 .07-.07.07l-.12-.02Zm.14 1.08-.05-.07-.1-.07.1.14h.05Zm.2 0-.08-.12-.1-.1.03.1.12.12h.03Zm.19 0-.08-.14-.07-.17c-.05-.02 0 .05 0 .05l.05.12.05.1.05.04Zm.14-.1v-.16l-.07-.12v.12l.07.17v-.01Zm.32.08-.08-.17-.07-.14v.1l.07.19.08.02Zm.26-.31-.14-.08-.22-.05.02.03.05.02.1.05.14.05.05-.02Z"
                    />
                    <path
                        fill="#202020"
                        d="M10 7.72s0 .07.04.14l.17.17.07.22.05.17.03.07-.05-.07v-.07l-.1-.3c-.02-.02-.2-.14-.24-.24l-.05-.1H10v.01Z"
                    />
                    <path
                        fill="#202020"
                        d="M10.19 8.13c-.03-.05-.12-.15-.17-.15l-.07-.02-.15-.15v.03l.17.17c.05.05.07.14.1.22l.02.1.05.04.02-.02c-.02 0-.07-.05-.1-.12-.02-.05-.04-.17-.09-.22v-.03h.05l.17.15Zm-.15-.58.12.07h.05s0 .17.07.27l.13.12s0 .17.04.29c.03.1.05.2.05.29l-.07-.15-.07-.24.07.2.02-.05-.04-.15-.05-.17-.07-.12-.1-.2v-.04l-.07-.02-.08-.1Z"
                    />
                    <path
                        fill="#202020"
                        d="m10.28 7.52.08.05.07.03s0 .14.05.24l.12.17.05.24.02.31-.02.4-.03-.3-.1-.26-.04-.32c-.03-.07-.07-.07-.07-.07a.12.12 0 0 0 .07.07l.05.32c.05.16.12.26.12.26l-.05-.36-.02-.3-.13-.14c-.04-.07-.02-.2-.04-.24l-.05-.02c-.08-.03-.08-.08-.08-.08Z"
                    />
                    <path
                        fill="#202020"
                        d="m10.45 7.43.1.1.12.04c.03.03-.02.15.05.27l.1.14.02.51c.03.12.03.56-.02.56s0-.32-.03-.39l-.05-.12c-.02-.05-.02-.29-.07-.41C10.65 8 10.6 8 10.6 8s.05.02.07.1l.07.4.08.15-.03-.56-.14-.36V7.6l-.12-.05a.26.26 0 0 1-.1-.12h.02Z"
                    />
                    <path
                        fill="#202020"
                        d="M10.7 7.5c.02 0 .04.07.14.1l.22.04s.1.17.1.4c0 .21-.05.19-.08.35l-.05.61-.04.07c0 .03.02.1-.03.1s-.02-.05-.02-.07l.02-.25-.02-.21-.03-.54-.1-.12.1.1.03.56c.02.07.02-.03.02-.08L11 8.2l-.08-.39.05.08.03.02h-.03l.05.3v.6l.05-.42c.02-.19.07-.21.07-.36 0-.14-.05-.34-.1-.34a.39.39 0 0 1-.19-.07.4.4 0 0 1-.14-.12h-.01Zm-1.31.22h.05l.14-.12v-.08l.03.03c.02 0 .1-.05.1-.1v-.12h.04c.03-.02.08-.05.08-.1l-.03-.1h.05c.02 0 .1-.04.1-.09 0-.05-.03-.12-.1-.12h.1c.04-.03.04-.05.04-.07l-.1-.17h.13l.02-.1-.02-.05h.1l.14-.07c.02 0-.1.05-.1.1l.08.07h.02l.12.02-.1.03.22.2.05.01h.05-.07l.12.17.05.03.02.02h-.05c.05.07.09.15.12.22l-.24-.34-.17-.17.15.24.12.22s-.15-.29-.34-.46l-.24-.2-.03.18c0 .02.17.12.3.26l.26.4s-.1-.18-.3-.37l-.26-.24-.05.04-.07.05.2.17.07.03.05.05-.05-.03h-.05l.14.17.08.02.07.03-.1-.03h-.02l.07.15-.26-.3c-.13-.11-.17-.11-.17-.11l-.05.05-.05.02.2.2.14.16-.17-.14-.15-.12v.07l.17.2-.21-.22-.03.02-.05.05.24.26-.21-.16.07.19-.12-.2-.05.05-.07.05.17.22-.2-.2v.03l.05.15-.07-.13-.05.05-.05.03.05.07.02.1s0-.08-.04-.1l-.05-.05-.05.03v-.05Z"
                    />
                    <path
                        fill="#202020"
                        d="M11.06 7.65h.07l-.07-.08c-.05-.05-.2-.46-.34-.65a2.2 2.2 0 0 0-.46-.46s.27.14.46.46c.22.31.27.56.34.6.05.08.12.08.12.1l-.05.05h-.07v-.02Zm-1.77-.08.1-.1s-.05 0-.07-.04l-.03-.05.05.05.05.02.12-.12-.07-.02c-.05-.03-.03-.08-.03-.08l.05.05h.08l.07-.14-.07-.03-.05-.07s.02.05.07.05l.07-.03V6.9h-.1c-.04 0-.04-.08-.04-.08l.07.05c.05 0 .07-.02.07-.05v-.1l-.05-.1-.07.03c-.05 0-.07-.05-.07-.05l.07.03c.05 0 .07-.05.07-.07l-.04-.08c-.03-.02 0-.07-.03-.04h-.07l.07-.05-.1-.12a2.15 2.15 0 0 0-.12-.1l.15.1.1.1h.07l-.03-.1-.07-.1.1.1v.1c.02.02.14.07.17.04.02-.02 0-.05-.03-.07l-.02-.07.05.07.02.07-.02.03.07.04.1.03.02-.07v.1h.05l-.1.02c-.07 0-.26-.15-.29-.12-.02.02.12.07.17.12l.07.1-.07-.06-.17-.07.05.03-.05.07.17.14-.05.05-.1-.07.05.07-.02.05.1.12-.05.07.07.08-.07-.05-.05-.05-.05.07.05.1v.1l-.07-.1-.05.02-.02.1c0 .02.04.02.04.07l-.02.1-.07-.1-.1.1.05.05-.07.02-.08.03v-.03Z"
                    />
                    <path
                        fill="#202020"
                        d="M10.26 6.46v-.02s.07-.08.05-.1l-.12.02-.17-.1s-.34-.24-.87-.26c-.17 0-.24.05-.24.07 0 .03.02-.05.19-.05.1 0 .63.05.9.27.02 0 .12.1.19.07h.1l-.03.05-.02.05h.02Zm-.94.07c0-.02-.03-.07-.1-.12-.07-.07-.29-.14-.29-.17l.29.17.1.12Z"
                    />
                    <path
                        fill="#D2A567"
                        d="m9.32 6.92-.05-.05a.36.36 0 0 0-.1-.05l.1.03c.05.02.05.07.05.07Zm-.03-.2-.07-.04-.1-.03h.12a.1.1 0 0 1 .05.08v-.01Zm-.02-.16L9.2 6.5l-.12-.03h.12l.07.08v.01Zm-.07-.12-.15-.05-.14-.03h.19l.1.08Zm-.22-.1-.12-.03h-.17l.24-.02c.05 0 .05.05.05.05Z"
                    />
                    <path
                        fill="#F8C83C"
                        d="M8.37 8.64s.05.05.1.05.12.1.12.1l-.07.06h-.17l-.05-.07.07-.14Zm0-.08-.07-.14v.07l-.02.05s.05.05.02.07l.07-.05Z"
                    />
                    <mask
                        id="H"
                        width="1"
                        height="1"
                        x="8"
                        y="8"
                        maskUnits="userSpaceOnUse"
                    >
                        <path
                            fill="#977C2E"
                            d="M8.37 8.64s.05.05.1.05.12.1.12.1l-.07.06h-.17l-.05-.07.07-.14Zm0-.08-.07-.14v.07l-.02.05s.05.05.02.07l.07-.05Z"
                        />
                    </mask>
                    <g mask="url(#H)">
                        <path
                            fill="#977C2E"
                            d="m8.37 8.64.25-.25-.34-.34-.22.43.31.16Zm.22.14.25.25.21-.22-.18-.24-.28.21Zm-.07.07v.35h.14l.1-.1-.24-.25Zm-.17 0-.3.2.11.15h.19v-.35Zm-.05-.07L8 8.63l-.1.18.12.17.3-.2H8.3Zm.07-.22.2.3.25-.18-.13-.27-.32.15Zm-.07-.14.31-.16-.66.16h.35Zm0 .07.31.16.04-.08V8.5H8.3v-.01Zm-.02.05-.32-.16-.1.23.17.18.25-.25Zm.02.07-.25-.24.45.53-.2-.29Zm.07.03-.24.24v.01l.08.06c.04.03.13.09.26.09v-.7c.05 0 .09 0 .13.03l.02.02-.25.25Zm.1.4a.3.3 0 0 1-.15-.05H8.3h.01l.28-.2.28-.22a.63.63 0 0 0-.17-.16.42.42 0 0 0-.23-.07v.7Zm-.13-.5-.07.07.5.5.07-.08-.5-.5v.01Zm.18-.04h-.17v.7h.17v-.7Zm.12.16L8.6 8.6l-.58.39.05.07.58-.39-.01-.01Zm-.03.28.08-.15-.63-.31-.07.15.62.3v.01Zm.08-.53-.08-.15-.62.32.07.14.63-.31Zm-.74 0v.08h.7v-.07h-.7v-.01ZM8 8.35l-.03.04.63.32.02-.05L8 8.34v.01Zm.29.2-.25.25A.2.2 0 0 1 8 8.74a.29.29 0 0 1-.04-.1.32.32 0 0 1 .1-.28l.49.49c.1-.1.12-.23.1-.32a.42.42 0 0 0-.12-.24l-.25.24.01.02Zm.22.36.07-.04-.4-.59-.06.05.39.58Z"
                        />
                    </g>
                    <path
                        fill="#F8C83C"
                        d="M8.35 8.73h.05l.05-.02m-.12-.02s.1-.08.07-.1l-.03-.03-.07.05.03.08Z"
                    />
                    <mask
                        id="I"
                        width="1"
                        height="1"
                        x="8"
                        y="8"
                        maskUnits="userSpaceOnUse"
                    >
                        <path
                            fill="#977C2E"
                            d="M8.35 8.73h.05l.05-.02m-.12-.02s.1-.08.07-.1l-.03-.03-.07.05.03.08Z"
                        />
                    </mask>
                    <g mask="url(#I)">
                        <path
                            fill="#977C2E"
                            d="M8.4 8.73v.35h.08l.07-.03-.15-.32Zm-.07-.04-.34.1.16.47.39-.3-.21-.27Zm.04-.13.25-.24-.2-.2-.24.15.2.3-.01-.01Zm-.07.05-.2-.29-.22.15.09.25.33-.1v-.01Zm.05.47h.05v-.7h-.05v.7Zm.2-.03.05-.03-.31-.62-.05.02.31.63Zm-.22-.36.2.28a.93.93 0 0 0 .17-.18.36.36 0 0 0-.06-.44l-.49.49a.34.34 0 0 1-.06-.4l.03-.03V8.4l.2.29h.01Zm.32-.35-.03-.02-.5.5.03.02.5-.5Zm-.47-.07-.07.05.39.58.07-.04-.4-.59h.01Zm-.21.45.02.08.67-.23-.03-.07-.66.22Z"
                        />
                    </g>
                    <path
                        fill="#F8C83C"
                        d="m8.25 8.73.05.05.07-.05-.04-.04h-.08v.04Z"
                    />
                    <mask
                        id="J"
                        width="1"
                        height="1"
                        x="8"
                        y="8"
                        maskUnits="userSpaceOnUse"
                    >
                        <path
                            fill="#977C2E"
                            d="m8.25 8.73.05.05.07-.05-.04-.04h-.08v.04Z"
                        />
                    </mask>
                    <g mask="url(#J)">
                        <path
                            fill="#977C2E"
                            d="M8.25 8.73H7.9v.15l.1.1.25-.25Zm.05.05-.25.25.2.2.25-.16-.2-.29Zm.07-.05.2.3.35-.24-.3-.3-.25.24Zm-.04-.04.24-.25-.1-.1h-.14v.35Zm-.08 0v-.35H7.9v.35h.35Zm-.24.3.04.04.5-.5-.05-.04-.5.5h.01Zm.49.08.07-.04-.4-.59-.06.05.39.58Zm.12-.58-.05-.05-.5.5.06.04.5-.5-.01.01Zm-.3-.15h-.07v.7h.08v-.7h-.01Zm-.42.35v.04h.7V8.7h-.7v-.01Z"
                        />
                    </g>
                    <path
                        fill="#F8C83C"
                        d="m8.35 8.69-.1.04c-.02.03-.05-.07-.05-.07h.05l.05-.05.03.03.02.05Z"
                    />
                    <mask
                        id="K"
                        width="1"
                        height="1"
                        x="8"
                        y="8"
                        maskUnits="userSpaceOnUse"
                    >
                        <path
                            fill="#977C2E"
                            d="m8.35 8.69-.1.04c-.02.03-.05-.07-.05-.07h.05l.05-.05.03.03.02.05Z"
                        />
                    </mask>
                    <g mask="url(#K)">
                        <path
                            fill="#977C2E"
                            d="m8.35 8.69.16.3.3-.15-.15-.31-.31.16Zm-.1.04-.15-.3-.05.02-.04.04.24.24Zm-.05-.07v-.35h-.44l.1.44.34-.09Zm.05 0v.35h.15l.1-.1-.25-.25Zm.05-.05.25-.24-.25-.25-.25.25.25.24Zm.03.03.3-.16-.02-.05-.04-.04-.24.25Zm-.14-.27-.1.05.32.63.1-.05-.32-.63Zm-.18.12a.34.34 0 0 1 .27-.1.34.34 0 0 1 .25.16l.01.02-.34.1-.34.08.04.1c0 .01.03.07.09.13.03.03.1.1.21.1.14.02.24-.04.3-.1l-.5-.5.01.01Zm.2.52h.04v-.7H8.2v.7h.01Zm.29-.1.05-.05-.5-.5-.04.05.49.5Zm-.45-.05.03.02.5-.49-.03-.02-.5.49Zm-.04-.07.03.05.62-.31-.02-.05-.63.31Z"
                        />
                    </g>
                    <path
                        fill="#F8C83C"
                        d="m8.1 8.64.13.02-.1.05c-.05 0-.02-.07-.02-.07H8.1Z"
                    />
                    <mask
                        id="L"
                        width="1"
                        height="1"
                        x="8"
                        y="8"
                        maskUnits="userSpaceOnUse"
                    >
                        <path
                            fill="#977C2E"
                            d="m8.1 8.64.13.02-.1.05c-.05 0-.02-.07-.02-.07H8.1Z"
                        />
                    </mask>
                    <g mask="url(#L)">
                        <path
                            fill="#977C2E"
                            d="m8.1 8.64.08-.35-.3-.06-.1.3.33.1-.01.01Zm.13.02.15.31.92-.45-1-.2-.07.34Zm-.1.05v.35h.08l.08-.04-.16-.31Zm-.1.27.13.02.14-.68-.12-.03-.14.69h-.01Zm.04-.63-.1.05.32.62.1-.05-.32-.62Zm.06.01a.32.32 0 0 1 .27.14.3.3 0 0 1 .05.22v.02h-.01l-.33-.1-.33-.11-.02.04v.1c0 .04 0 .13.06.22.07.12.2.17.31.17v-.7Z"
                        />
                    </g>
                    <path
                        fill="#202220"
                        d="M7.82 8.8s0 .08.05.08l.12-.05-.15-.07-.02.05V8.8Z"
                    />
                    <path
                        fill="#4B4139"
                        d="M7.82 8.8h-.03l.03.05.05.03h.02l.1-.05v-.02l-.15-.05-.05.05h.03l.02-.03.15.05v-.02l-.03.02-.07.05h-.02l-.05-.05V8.8Z"
                    />
                    <path
                        fill="#202220"
                        d="M7.84 8.8s.03.03.1.03.12-.05.12-.05l-.12-.07-.1.1V8.8Z"
                    />
                    <path
                        fill="#4B4139"
                        d="M7.84 8.8s.03.05.1.05.12-.07.12-.07l-.12-.1-.1.13.1-.1.12.07-.12.05-.07-.02h-.03V8.8Z"
                    />
                    <path
                        fill="#4B4139"
                        d="m7.84 8.8.07.03H8h-.12v-.02h-.03l-.01-.01Z"
                    />
                    <path
                        fill="#202220"
                        d="M7.94 8.73s.02.1.1.08l.04-.05-.07-.1-.07.07Z"
                    />
                    <path
                        fill="#4B4139"
                        d="M7.94 8.73v.05l.07.03h.02l.05-.03v-.02l-.07-.1-.07.07v.03l.07-.1.07.1c0 .02 0 .05-.05.05h-.02l-.05-.03-.02-.02v-.03Z"
                    />
                    <path
                        fill="#4B4139"
                        d="M7.94 8.76 8 8.8l.05-.03v.03h-.07l-.03-.03-.02-.02.01.01Zm-.12.07.05.02h.07-.03l-.02.03h-.05v-.03l-.02-.02Z"
                    />
                    <path
                        fill="#F8C83C"
                        d="M7.8 8.69s-.08 0-.08.02l.05.07.07-.02-.05-.07h.01Z"
                    />
                    <mask
                        id="M"
                        width="1"
                        height="1"
                        x="7"
                        y="8"
                        maskUnits="userSpaceOnUse"
                    >
                        <path
                            fill="#977C2E"
                            d="M7.8 8.69s-.08 0-.08.02l.05.07.07-.02-.05-.07h.01Z"
                        />
                    </mask>
                    <g mask="url(#M)">
                        <path
                            fill="#977C2E"
                            d="m7.8 8.69.28-.2-.1-.15h-.19v.35h.01Zm-.08.02h-.35v.1l.06.1.29-.2Zm.05.07-.3.2.16.22.25-.09-.11-.33Zm.07-.02.11.33.44-.14-.26-.39-.29.2Zm-.05-.07v-.35h-.1a.44.44 0 0 0-.26.17.37.37 0 0 0-.06.2h.7a.34.34 0 0 1-.18.3l-.08.02H7.8V8.7l-.01-.01Zm-.36.21.05.08.58-.4-.05-.06-.58.38Zm.45.21.07-.02-.22-.66-.07.02.22.66Zm.25-.55-.05-.07-.58.39.05.07.58-.39Z"
                        />
                    </g>
                    <path
                        fill="#9CA168"
                        d="m7.99 8.64-.02-.01-.02-.02-.04-.02-.03-.02.03-.02.05-.01c.03 0 .03.04.03.07v.03Zm0 0-.03.03c-.01.01-.03.03-.05.02-.04 0-.07-.05-.07-.08h.07l.05.02H8l-.01.01Z"
                    />
                    <path
                        fill="#F8C83C"
                        fillRule="evenodd"
                        d="M9.3 9.31h-.13v.08l.05.02.07-.02v-.02l.03.02-.03.02-.07.03.02.04.1.03.05-.05v-.03h.02l.1-.07-.02-.05h-.05l-.03-.07-.07.05-.05.02h.01Zm.31-.04.02.02.05.02.02.03.05.02.03.03.02.04-.05.03H9.7l-.04-.05h-.03l-.05-.02.02-.03h-.07V9.2l.08.08v-.01Z"
                        clipRule="evenodd"
                    />
                    <mask
                        id="N"
                        width="1"
                        height="1"
                        x="9"
                        y="9"
                        maskUnits="userSpaceOnUse"
                    >
                        <path
                            fill="#977C2E"
                            fillRule="evenodd"
                            d="M9.3 9.31h-.13v.08l.05.02.07-.02v-.02l.03.02-.03.02-.07.03.02.04.1.03.05-.05v-.03h.02l.1-.07-.02-.05h-.05l-.03-.07-.07.05-.05.02h.01Zm.31-.04.02.02.05.02.02.03.05.02.03.03.02.04-.05.03H9.7l-.04-.05h-.03l-.05-.02.02-.03h-.07V9.2l.08.08v-.01Z"
                            clipRule="evenodd"
                        />
                    </mask>
                    <g mask="url(#N)">
                        <path
                            fill="#977C2E"
                            d="M9.3 9.31h.34v-.35H9.3v.35Zm-.13 0v-.35h-.35v.35h.35Zm0 .08h-.35v.21l.2.1.15-.31Zm.05.02-.16.31.13.07.14-.05-.11-.33Zm.07-.02.11.33.24-.08v-.25h-.35Zm0-.02.16-.3-.5-.26v.56h.34Zm.03.02.24.24.35-.34-.44-.22-.15.32Zm-.03.02.11.33.08-.02.06-.06-.25-.25Zm-.07.03-.11-.34-.38.13.18.36.31-.15Zm.02.04-.3.16.06.14.16.04.08-.34Zm.1.03-.08.34.19.05.14-.14-.25-.25Zm.05-.05.25.25.1-.1v-.15h-.35Zm0-.03v-.35h-.35v.35h.35Zm.02 0v.35h.12l.1-.07-.22-.28Zm.1-.07.21.28.23-.17-.13-.26-.3.15h-.01Zm-.02-.05.31-.15-.1-.2h-.2v.35h-.01Zm-.05 0-.33.11.08.24h.25v-.35Zm-.03-.07.34-.1-.15-.44-.38.25.2.3-.01-.01Zm-.07.05.16.31h.02l.02-.02-.2-.29Zm-.05.02-.15-.3-.1.04-.06.1.31.16Zm0 0h-.35l.67.16-.32-.16Zm.03.08.24-.25-.1-.1h-.14v.35Zm0 0v-.35l-.11.68.1-.33h.01Zm0 0-.11.33.35-.58-.24.25Zm.31-.1-.25.25.35.34.21-.43-.3-.16h-.01Zm0 0 .16-.31-.32-.16-.15.31.31.16Zm.05.02.25-.24-.04-.04L9.84 9l-.16.31Zm.02.03h.35v-.15l-.1-.1-.25.25Zm0 0h-.35v.84l.6-.6-.25-.24Zm0 0 .16-.31-.22-.12-.18.18.24.25Zm.05.02.25-.25-.04-.04-.05-.02-.16.31Zm.03.03.31-.16-.03-.05-.04-.04-.24.25Zm.02.04.16.32.31-.16-.16-.31-.3.15H9.8Zm-.05.03v.35h.09l.07-.04-.16-.31Zm-.05 0-.24.25.1.1h.14v-.35Zm-.04-.05.24-.25-.1-.1h-.14v.35Zm-.03 0-.15.31.07.04h.08v-.35Zm-.05-.02-.31-.16-.16.31.32.16.15-.31Zm.02-.03.3.16.26-.5H9.6v.34Zm-.07 0h-.35v.35h.35v-.35Zm0-.17.25-.24-.6-.6v.84h.35Zm-.33.47h.1v-.7h-.1v.7Zm-.03 0h.03v-.7h-.03v.7Zm.35-.27V9.3h-.7v.08h.7v.01Zm-.14-.3-.05-.02-.31.63.04.02.32-.62v-.01Zm-.2-.04-.07.03.22.66.07-.02-.22-.67Zm-.24.32v.02h.7v-.02h-.7Zm.53-.3h-.02l-.31.62.02.01.31-.63Zm.07.59.02-.03-.49-.5-.02.03.49.5Zm-.2.1.06-.02-.22-.66-.07.02.22.67.01-.01Zm.22-.43-.03-.05-.62.31.02.05.63-.31Zm-.13-.16-.1-.03-.17.68.1.03.17-.68Zm-.29.04-.05.05.5.5.05-.05-.5-.5Zm-.1.22v.03h.7v-.03h-.7Zm.35.35h.02v-.7H9.4v.7h-.01Zm.23-.07.1-.07-.42-.56-.1.07.42.56Zm.2-.5-.02-.05-.63.31.03.05.62-.31Zm-.33-.25h-.05v.7h.05v-.7Zm-.4.4.02.06.66-.22-.02-.07-.67.22.01.01Zm.45.22.07-.05-.39-.58-.07.05.39.58Zm-.09.05.05-.03-.32-.62-.04.02.31.63Zm.42-.59-.02-.02-.49.5.02.02.5-.5h-.01ZM9.84 9l-.05-.02-.31.62.04.03.32-.63Zm.11.1-.02-.03-.5.5.03.02.5-.5-.01.01Zm-.04-.05-.05-.02-.31.62.05.03.3-.63h.01Zm.11.09L10 9.1l-.5.5.03.02.5-.5-.01.02Zm.1.14-.03-.05-.63.31.03.05.62-.31h.01Zm-.21.5.05-.03-.32-.63-.04.03.3.62.01.01Zm-.2.03h.04v-.7H9.7v.7h.01Zm-.3-.15.05.05.5-.5-.06-.05-.5.5h.01Zm.22.1h.03v-.7h-.03v.7Zm-.2-.06.05.02.3-.62-.04-.03-.31.63Zm-.15-.5-.01.03.63.31v-.02l-.62-.31V9.2Zm.25.51h.07v-.7h-.07v.7Zm-.35-.52v.17h.7V9.2h-.7v-.01Zm.67-.17-.07-.07-.5.5.08.06.5-.5-.01.01Z"
                        />
                    </g>
                    <path
                        fill="#F8C83C"
                        d="M9.63 9.46h.03l.02.02.05.08h.12l.07-.08-.02-.02s.02-.07-.03-.07h-.1l-.04.07-.05-.02-.02-.05h-.03l-.02-.05h-.05l-.03-.03-.07.05-.02.05-.07.03s-.03.07-.05.04c-.05 0-.08-.04-.08-.04l-.07.02-.02.05.02.1c0 .02.07.04.12 0 .05-.03.03-.08.03-.08h.05l.1-.07"
                    />
                    <path
                        fill="#F8C83C"
                        d="M9.53 9.1v.24c-.02.05-.1.02-.12 0v-.12l.12-.12Z"
                    />
                    <mask
                        id="O"
                        width="1"
                        height="1"
                        x="9"
                        y="9"
                        maskUnits="userSpaceOnUse"
                    >
                        <path
                            fill="#977C2E"
                            d="M9.53 9.1v.24c-.02.05-.1.02-.12 0v-.12l.12-.12Z"
                        />
                    </mask>
                    <g mask="url(#O)">
                        <path
                            fill="#977C2E"
                            d="M9.53 9.1h.35v-.85l-.6.6.25.25Zm0 .24.32.15.03-.07v-.08h-.35Zm-.12 0h-.35v.14l.1.1.25-.24Zm0-.12-.24-.25-.1.1v.15h.34Zm-.23-.12v.24h.7V9.1h-.7Zm.04.08a.3.3 0 0 1 .16-.14c.06-.03.11-.03.14-.02l.07.02.07.05-.5.5c.08.07.17.1.27.12.1.02.31 0 .42-.22l-.63-.3v-.01Zm.54.16v-.12h-.7v.12h.7Zm-.1.12.12-.12-.5-.5-.11.13.5.5-.01-.01Z"
                        />
                    </g>
                    <path
                        fill="#F8C83C"
                        d="M9.44 9.44s0 .04.05.04l.02-.02.02-.02s0 .04.05.04.05-.04.05-.04"
                    />
                    <mask
                        id="P"
                        width="1"
                        height="1"
                        x="9"
                        y="9"
                        maskUnits="userSpaceOnUse"
                    >
                        <path
                            fill="#977C2E"
                            d="M9.44 9.44s0 .04.05.04l.02-.02.02-.02s0 .04.05.04.05-.04.05-.04"
                        />
                    </mask>
                    <g mask="url(#P)">
                        <path
                            fill="#977C2E"
                            d="M9.49 9.48v.35h.14l.1-.1-.24-.25Zm.04-.04h.35v-.85l-.6.6.25.25Zm-.1 0H9.1a.3.3 0 0 0 0 .06l.04.12a.4.4 0 0 0 .36.21v-.7c.05 0 .1.02.16.05a.3.3 0 0 1 .14.25h-.35l-.02.01Zm.3.3.03-.03-.5-.5-.02.03.5.5h-.01Zm.03-.03.02-.03-.5-.5-.02.03.5.5Zm-.23-.27h-.35l.01.06c0 .03.01.07.04.12a.4.4 0 0 0 .35.21v-.7a.4.4 0 0 1 .17.05.3.3 0 0 1 .13.25h-.35v.01Zm.05.4a.4.4 0 0 0 .36-.22.41.41 0 0 0 .04-.18h-.7v-.05l.03-.09a.3.3 0 0 1 .27-.17v.71Z"
                        />
                    </g>
                    <path
                        fill="#202220"
                        d="M9 9.53s-.02-.05 0-.05h.08l.02-.07-.02-.05c-.03 0-.15 0-.15.1 0 .07.07.07.07.07Zm.2.2s-.05-.05-.03-.08l.05-.02v-.05l-.05-.07s-.1.07-.07.12c0 .1.1.1.1.1Zm.65-.05s.14.05.14-.1c0-.05-.04-.1-.07-.1l-.05.03-.02.05c0 .02.05 0 .05.04.05.08-.05.08-.05.08Z"
                    />
                    <path
                        fill="#4B4139"
                        d="M9.2 9.73s-.12-.03-.12-.13c0-.04.07-.1.07-.1s-.05.06-.05.1c0 .1.1.13.1.13Zm-.2-.2s-.07 0-.07-.1.15-.07.15-.07-.15 0-.15.1c.03.07.07.07.07.07Zm.85.15h.07c.05 0 .05 0 .07-.05.03-.05 0-.07-.02-.12l.02.12c0 .07-.07.05-.1.05a.2.2 0 0 1-.04 0Z"
                    />
                    <path
                        fill="#904720"
                        d="M8.3 6.92h-.02l.02-.05.07-.02h.15l.02.02.05.07-.14.1h-.03v-.02l-.02-.08-.1-.02Z"
                    />
                    <path
                        fill="#202020"
                        d="M9.58 8.88v-.2l-.55.17.21.2.34-.17Z"
                    />
                    <path
                        fill="#D2A567"
                        d="m8.57 8.54-.05-.05-.05-.02h-.05v.02l.05.07.1.03.02.05h.03l-.05-.1Zm-.03.07h.05l.03.05.02.05.02.05v.02l-.04-.02-.2-.05.03-.05.02-.02h.02l.05-.03Z"
                    />
                    <path
                        fill="#D2A567"
                        d="M8.66 8.76h.05v-.3l-.14-.16-.03.1.05.16.03.1.04.1Z"
                    />
                    <path
                        fill="#AB6D29"
                        d="M8.57 8.37v.07c.02.05.02.2.07.27.05.1-.05-.05-.05-.05s-.07-.2-.05-.31c.03-.12.03.02.03.02Z"
                    />
                    <path
                        fill="#AB6D29"
                        d="m8.66 8.5-.02.06v.08l.02-.05.03.1.02-.17-.05-.03v.01Zm.03.33-.17-.02-.12-.1.17.02.1.03h.02l.07-.03v.08l-.07.02Zm-.27-.02v.04h-.07l.14.05.05-.02-.12-.07Z"
                    />
                    <path
                        fill="#D2A567"
                        d="m8.37 8.76.08.05c.07.02.07-.03.07-.03l.02.03h.03l-.03.04-.1-.02-.04-.05-.03-.02Z"
                    />
                    <path
                        fill="#AB6D29"
                        d="m8.74 8.69.02.04.02-.1v-.09l-.07-.02.03.17Z"
                    />
                    <path
                        fill="#4D2A15"
                        d="m8.57 8.54-.05-.07-.05-.12.02-.08.05.08v.1l.03.09Z"
                    />
                    <path
                        fill="#D2A567"
                        d="m8.25 8.83.05-.02h.1l.1.04.02.03-.2-.03-.07-.02Z"
                    />
                    <path
                        fill="#8F4620"
                        d="M8.74 8.5v.16l.02.07-.02.03h-.08.05l-.02-.1-.03-.1-.02.03.02-.15.08.05v.01Z"
                    />
                    <path
                        fill="#AB6D29"
                        d="m8.4 8.8-.03-.04c0-.03.03.07.12.07l.1-.02h.05l-.02.04-.08.08h-.02l-.03-.08-.07-.04H8.4V8.8Z"
                    />
                    <path
                        fill="#8F4620"
                        d="m8.57 8.54-.15-.2c-.05-.09-.02-.19-.02-.19l.12.15-.03.07.08.17Z"
                    />
                    <path
                        fill="#AB6D29"
                        d="m8.5 9 .02-.07c.07-.1.24-.15.24-.15v.1L8.52 9h-.03.01Z"
                    />
                    <path
                        fill="#8F4620"
                        d="m8.52 8.9.05-.05-.1-.02a.36.36 0 0 1-.07-.02l.07.04.02.03.03.02Zm.29.03-.03-.08-.02-.07-.05.03-.05.02.08.02-.12.03h.07l-.07.05-.1.05-.03.02h.05l.12-.02.15-.05Z"
                    />
                    <path
                        fill="#AB6D29"
                        d="M8.8 8.93s-.02 0-.04-.17c-.05-.17-.02-.22-.02-.22l.04.05.08.12-.05.22H8.8Z"
                    />
                    <path
                        fill="#8F4620"
                        d="m8.83 8.66-.02.15v.12l.07.1.03-.03.02-.07V8.8l-.1-.15v.01Z"
                    />
                    <path
                        fill="#202020"
                        d="M8.93 8.78s.02.24-.05.24l-.07-.1s.05.1.07.08c.05 0 .03-.24.03-.24l.02.02Zm-.12.15-.03-.03c-.02-.02 0 .03-.12.08l.12-.05h.03Z"
                    />
                    <path
                        fill="#AB6D29"
                        d="m8.6 8.64.02.07.04.07-.02-.1-.1-.12.05.08h.01Z"
                    />
                    <path
                        fill="#8F4620"
                        d="M8.52 8.93v-.05l-.12-.03c-.05 0-.1 0-.15-.02l.1.05.14.05h.03Z"
                    />
                    <path
                        fill="#202020"
                        d="m8.52 8.93-.03-.03-.12-.02-.12-.05s.03.05.12.05l.15.05Z"
                    />
                    <path
                        fill="#AB6D29"
                        d="m8.57 8.61-.12.03-.05.07.05.02.02-.07.1-.05Z"
                    />
                    <path
                        fill="#8F4620"
                        d="m8.4 8.47.07.05.07.04.05.08-.14-.08-.05-.1v.01Z"
                    />
                    <path
                        fill="#8F4620"
                        d="m8.52 8.5-.05-.03H8.4l.05.07.02-.02-.05-.05c.03-.03.1.02.1.02v.01Z"
                    />
                    <path
                        fill="#202020"
                        d="m8.8 8.35.64-.32.31.41-.55.15-.3.02-.12-.1.03-.16H8.8Z"
                    />
                    <path
                        fill="#4D2A15"
                        d="m9.66 8.54.77.68-.07.05-.2-.05-.36-.39-.14-.12v-.17Zm.99.53-.44-.34-.55-.4v.19l.65.58.22.12.1-.05.04-.05-.02-.05Z"
                    />
                    <path
                        fill="#803F1D"
                        d="M9.66 8.59c.21.26.47.48.77.65.05 0 .02-.05.02-.05l-.8-.65v.05h.01Z"
                    />
                    <path
                        fill="#4D2A15"
                        d="m10.21 9.24-.07.07-.1-.04-.48-.49.02-.1.08.03.55.53Z"
                    />
                    <path
                        fill="#202020"
                        d="M10.65 9.07s-.05.15-.17.12c-.12-.04-.82-.7-.82-.7v.07s.7.63.84.66c.15.02.24-.07.22-.1l-.07-.05Z"
                    />
                    <path
                        fill="#803F1D"
                        d="m9.58 8.71.34.39c.12.12.22.19.27.17.05 0-.03-.05-.03-.05l-.33-.34-.17-.17s-.08-.05-.08 0Z"
                    />
                    <path
                        fill="#202020"
                        d="m9.63 8.71.6.58c.1.02.25-.07.25-.07l-.05-.03v.03s-.02.05-.17.02a3.5 3.5 0 0 1-.6-.55l-.03.02Z"
                    />
                    <path
                        fill="#4D2A15"
                        d="m9.85 9.24-.22-.22-.02-.1-.03-.09.41.41-.04.05-.05-.02-.05-.03Z"
                    />
                    <path
                        fill="#202020"
                        d="M10.21 9.27s-.05.07-.12.04l-.1-.04-.38-.4-.03-.06s.44.46.51.48c.07.02.12-.05.12-.05v.03Z"
                    />
                    <path
                        fill="#202020"
                        d="M10 9.24s-.03.07-.08.05l-.07-.02-.24-.3V8.9s.24.34.31.37c.07.02.07-.05.07-.05v.02H10Z"
                    />
                    <path
                        fill="#B07229"
                        d="m9.75 8.5.24.21.1.02h-.05l.15.12.12.03h-.07l.12.12h.14l-.1.02c0 .03.18.13.15.15l-.2-.12-.02.05V9c0-.05-.14-.1-.14-.1l-.03.08v-.1l-.14-.1v.05l-.03-.07c-.02-.03-.26-.24-.24-.27v.01Z"
                    />
                    <path
                        fill="#4D2A15"
                        d="M9.34 9.15s0 .1-.02.1c-.05.02-.12-.18-.12-.18l-.03-.14.12.1.05.12Zm.32-.05V9l-.03-.1-.02-.05v-.04h-.03l-.07.04-.02.05.04.12.03.1.05.03.05-.05Zm-.08.14-.02-.12-.07-.17-.03-.07-.05-.03-.04.05.02.08.07.17c.03.02.1.12.12.1v-.01Z"
                    />
                    <path
                        fill="#202020"
                        d="m9.51 8.88.05.1.05.14h-.05l.1.07v-.1l-.03-.02-.05-.14v-.1s.08.1.08.17v.02-.12l-.05-.07.02-.07v-.03h.03l.04-.07-.02-.22-.24.34.07.1Z"
                    />
                    <path
                        fill="#202020"
                        d="m9.51 8.85.03.17.04.1v.12L9.48 9l-.02-.12h-.05l.1-.03Z"
                    />
                    <path
                        fill="#4D2A15"
                        d="M9.49 9.31V9.2l-.1-.17-.1-.1-.05-.07V9l.1.2.15.11Z"
                    />
                    <path
                        fill="#202020"
                        d="m9.12 8.9.03.08v.04l.07.13.07.12.05-.08-.05.05L9.2 9l-.02-.05-.05-.05h-.01Zm.27.22L9.32 9l-.05-.07-.03-.08.08.08.07.02v.17Zm0-.19.05-.05h.02l-.02-.03-.05-.04v.12Zm0 .02.1.2v.14l-.03-.12a5.3 5.3 0 0 1-.07-.22Z"
                    />
                    <path
                        fill="#4D2A15"
                        d="m9.49 8.85.02-.24-.02-.07-.1-.22-.05.03-.1-.08v.13l-.02.07.2.36.07.02Z"
                    />
                    <path
                        fill="#8B441F"
                        d="m9.1 9 .05.02-.03-.12-.29-.36.27.46Z"
                    />
                    <path
                        fill="#8B441F"
                        stroke="#5C3A1D"
                        strokeWidth=".1"
                        d="m9.03 8.7.16.15v.05a1.76 1.76 0 0 1-.16-.2Zm.17.2h.01v.02L9.2 8.9Z"
                    />
                    <path
                        fill="#202020"
                        d="m9.1 9-.05-.1v-.07l-.22-.29-.07-.05v.07c0 .03.05.13.15.22L9.1 9Z"
                    />
                    <path
                        fill="#4D2A15"
                        d="M9.39 8.95v-.14l-.17-.34-.05.02-.07-.07-.05-.05v.17l.12.22.22.2v-.01Zm.17-.2.05-.04-.03-.17-.1-.34-.07-.02-.04-.05.02.22.12.29v.1l.05.02v-.01Z"
                    />
                    <path
                        fill="#202020"
                        d="m9.24 8.83-.14-.17-.05-.1h-.07l-.1-.07s-.02.05.12.2c.17.19.24.14.24.14Z"
                    />
                    <path
                        fill="#8B441F"
                        d="M9.49 8.88c.04-.03.04-.22 0-.34l-.1-.22.1.27c.02.07 0 .14-.03.14l-.05-.12-.04-.1s.12.32.07.32c-.05 0-.2-.36-.2-.39l-.02.03s.17.46.27.4v.01Z"
                    />
                    <path
                        fill="#4D2A15"
                        d="m9.58 7.98.08.17.02.17v.12s0 .3-.02.3l-.05-.05-.08-.3-.04-.3.02-.03V8h.05l.02-.03v.01Z"
                    />
                    <path
                        fill="#8B441F"
                        d="M9.39 8.95v-.07h-.05l-.05-.12-.02-.05-.05.07-.17-.24-.02.02s.21.42.36.4v-.01Z"
                    />
                    <path
                        fill="#202020"
                        d="m9.3 8.76.02-.1-.1-.2h-.05l-.07-.04.07.17.12.17h.01Zm.11-.07-.07-.25-.1-.17v.15l.1.1.07.17Zm.15-.22-.03-.22-.04-.2h.04l.03.08V8H9.5l-.02.05-.03-.03v.03l.03.07-.03.05.05.14.05.15.01.01Zm.12-.03s.02-.19-.02-.31a.38.38 0 0 0-.08-.17l-.02.02.1.22.02.24Zm-.2.1-.04-.24-.03-.15-.04-.02.02.12v.05s0 .07.05.1l.05.14h-.01Z"
                    />
                    <path
                        fill="#904720"
                        d="M9.58 8.78c.05 0 .03-.22 0-.26l-.12-.32.12.39c-.02.02-.07-.12-.07-.12s.07.26.05.26L9.5 8.7v.04s.02.05.07.05l.01-.01Z"
                    />
                    <path
                        fill="#904720"
                        d="m9.63 8.69-.02-.32-.07-.27c.02.1.05.19.1.27l.02.34-.05-.02v-.03l.02.03Z"
                    />
                    <path
                        fill="#312317"
                        d="M9.27 8.93c.02.02.02.1-.03.07l-.12-.1s.08.1.12.1c.05 0 .03-.1 0-.12l.03.05Z"
                    />
                    <path
                        fill="#D2A567"
                        d="M9.49 7.94s.04.02.07 0l.07-.13-.02-.07c-.03-.02.05.03.02.07-.02.05.03.17-.07.2-.1.02-.05 0-.05 0l-.02-.07Z"
                    />
                    <path
                        fill="#8F4620"
                        d="m9.41 7.74.08.2v.12l-.03-.03-.05-.29Z"
                    />
                    <path
                        fill="#1E2121"
                        d="m8.37 7.86.4.58.47-.55-.31-.32-.56.3v-.01Z"
                    />
                    <path
                        fill="#4D2A15"
                        d="m8.86 7.52-.03.08.05.17.1.07.07.07.03-.07.02-.1h.02l.08.03.02-.05.07-.12v-.05l-.02-.03-.1-.17-.05.05-.02.03-.05-.03-.07.08-.1-.03-.02.07Z"
                    />
                    <path
                        fill="#5C3818"
                        d="m9.05 7.91.03-.07v-.22l-.05-.17s.05.12.05.27c0 .14 0 .17-.03.17v.02Zm.03-.24s.07.1.1.07c.04-.05.02-.14 0-.2l-.06-.11.03-.03.05.12c0 .05.04.2 0 .22-.05.03-.12-.05-.12-.05v-.02Z"
                    />
                    <path
                        fill="#8F4620"
                        d="m8.88 7.74.05-.02h.02l.03.07.05.07.05.05-.03.03h-.02l-.1-.05-.02-.03-.03-.12Z"
                    />
                    <path
                        fill="#D2A567"
                        d="M9.03 8.54c-.03.02-.1 0-.15-.05l-.24-.24-.02-.12.07.02.14-.07.03-.05.17-.07.1-.07h.21l.05-.1.07.17v.22l-.1-.05s.05.22 0 .22c-.04 0-.14-.08-.14-.08s.05.2 0 .2l-.2-.1s.06.15 0 .17h.01Z"
                    />
                    <path
                        fill="#8F4620"
                        d="m8.98 8.3.05.07v.12c-.03.03-.08-.05-.1-.12l-.07-.14.12.07Zm.41-.49s.07.32.05.32l-.15-.1-.17-.24-.02-.02.02-.03.05.03.22.04Zm-.5.59c-.03.02-.06-.03-.08-.05l-.1-.12-.1-.1-.02-.05.03-.02h.02l.22.17.02.17h.01Zm.28 0c0 .02-.14-.08-.2-.17l-.11-.17-.03-.08h.03l.31.42Zm.05-.13-.1-.1-.02-.09.12.2v-.01Zm.07-.02-.14-.2-.07-.09h-.05v-.02h.02l.03-.03.04-.05.15.32.02.07Z"
                    />
                    <path
                        fill="#AB6D29"
                        d="m8.88 8.5-.02.02a.95.95 0 0 1-.39-.3l-.1-.19.05-.05.34.42.12.1Z"
                    />
                    <path
                        fill="#8F4620"
                        d="M8.88 8.5c.03.02 0 .02-.02.02-.03 0-.12-.05-.27-.2-.14-.14-.2-.26-.2-.29v-.05l.03-.02.27.36.2.17-.01.01Z"
                    />
                    <path
                        fill="#4D2A15"
                        d="M9.12 8.35 9 8.23 8.86 8l.05-.03V7.9h.02l.05.03.1.1.02.04.05.15-.1-.08s.1.17.07.2v.01Zm-.14-.05.02.07c0 .03-.02.03-.05-.02l-.1-.12v.1l-.11-.13-.1-.14v-.17l.02.02v.03l.15.16.02-.02.08.15.07.07Zm-.49-.22.2.27.2.14-.3-.36-.1-.05Zm.78.1-.1-.12-.07-.2v-.12s.12.1.14.17l.05.12-.1-.05.08.2Zm.12-.12c0 .02-.07-.05-.07-.1l-.03-.1-.05-.12v-.12h.05l.08.1.02.12v.22Zm-.82.31-.17-.24-.03-.1.03.03s.02.12.17.26l.17.15s.04.07.02.1l-.2-.2h.01Z"
                    />
                    <path
                        fill="#202020"
                        d="M8.71 8.54 8.5 8.3l-.16-.24.04-.05.15.26.2.27h-.02Zm.17-.05-.22-.22a.46.46 0 0 1-.1-.17l.06.03.07.12.2.24h-.01Zm-.02-.26-.12-.15-.08-.14.15.14h.02v.07l.03.08Zm.05-.4v.13l-.05.02.07.1.1.07-.08-.12-.04-.1c.02-.02.1.03.1.05l.09.1-.05-.12-.14-.12v-.01Z"
                    />
                    <path
                        fill="#202020"
                        d="m9.22 8.06-.07-.17-.05-.2v.12l-.05.13H9h.08l.02-.08.05.1.07.1Z"
                    />
                    <path
                        fill="#202020"
                        d="M9.1 7.7s.07.09.1.04l.02-.14h.05l.02-.05.12.2.05.21s-.07-.1-.1-.22c-.02-.1-.07-.14-.1-.12v.1l.06.14.05.12-.08-.1-.05-.04-.07-.05-.07-.02v-.08.01Z"
                    />
                    <path
                        fill="#171717"
                        d="m8.83 8.06.08.14.07.1-.1-.1-.05-.14Z"
                    />
                    <path
                        fill="#8F4620"
                        d="M9.34 8.08H9.3l.03.1.05.02v-.12h-.04Z"
                    />
                    <path
                        fill="#D2A567"
                        d="m8.42 7.55-.02.02-.07.12.02.2.07.1.17.16.05-.14v-.12l.07.1.1.1.07-.15-.14-.37-.05-.05-.27.03Z"
                    />
                    <path
                        fill="#AB6D29"
                        d="m8.76 7.84.05.14v.1l.1-.17c.02-.05 0-.07-.03-.22-.02-.14 0-.19 0-.19l-.05-.02-.07.14v.22Zm-.27-.07.03.19.07.12.05-.17-.02-.22-.03-.14-.1.22Z"
                    />
                    <path
                        fill="#45392D"
                        d="M8.3 7.48s-.12.17-.12.26c0 .1.02.07.05.15l.05.21h.02v-.62Z"
                    />
                    <path
                        fill="#AB6D29"
                        d="M8.3 7.5s-.1.17-.1.24l.05.17.05.2.05-.03.07-.1-.02-.07-.03-.07-.02-.03v-.16l.02-.1V7.5H8.3Z"
                    />
                    <path
                        fill="#DBAD6C"
                        d="m8.86 7.77-.08-.03-.02-.05v-.02l.1.1Z"
                    />
                    <path
                        fill="#D2A567"
                        d="M8.33 7.52s-.08.15-.08.27l.08.24.02-.02-.02-.34.04-.1v-.05h-.04Z"
                    />
                    <path
                        fill="#8F4620"
                        d="M8.5 7.55v.07l-.05.07-.05.1.05-.05.04-.05v.1l-.04.07.02.1v-.1l.02-.02.05.07v-.07c0-.05.05-.07.05-.07s.03 0 0-.03v-.17l.07-.02-.07-.07-.1.07h.01Z"
                    />
                    <path
                        fill="#DBAD6C"
                        d="M8.83 7.86h-.05l-.02-.02.02-.03.03.03.02.02Z"
                    />
                    <path
                        fill="#8F4620"
                        d="m8.37 7.89-.02.05V8l-.02-.12v-.1l-.03.02v-.14l-.02.02-.03.05.03-.07.07-.12V7.5h.05l.02.07-.02.03-.05.12c-.02.12.02.12.02.17Zm.34-.32.03.1-.05.05-.03.1.03-.05.02-.05.03.07.04.1v-.05h.03l-.03-.07-.02-.08.05.03.05.05-.03-.03v-.2l.03-.06-.15.1v-.01Z"
                    />
                    <path
                        fill="#1E2121"
                        d="m9.12 7.43.03.12.02.14-.05-.14-.04-.12-.05.05.05.17-.05-.1L9 7.48v.07l.03.1L9 7.6l-.02-.03v.1-.02l.02.12.05.12-.07-.1c-.05-.07-.05-.29-.05-.31l.05-.08.05-.17.05.17.04.03Zm-.31-.05.02.05.03.05-.08.07c-.04.05-.12.07-.12.05l-.02-.03.1-.07.04-.07.03-.05Zm-.41.14s0 .08.05.08c.04 0 .14-.1.14-.1l.03-.05-.03-.02s-.1.12-.14.12l-.05-.03Zm0-.12v.12s-.07.03-.1 0v-.07h.05l.05-.05Zm.75-.12.07.12.05.12-.07-.07-.05-.05.02-.05-.02-.07Z"
                    />
                    <path
                        fill="#DBAD6C"
                        d="M8.3 7.45h.07l.03-.05v.1l.05.05.07-.05.07-.07.03.1c.02.04.02.04.07.02l.1-.1.02-.05.05-.02.02-.22-.02-.02-.05.02-.05-.02-.02-.03-.05.08-.03.02H8.6v-.02l-.02-.05h-.03l-.1.1H8.4l-.05.07-.02.04-.05.1h.02Z"
                    />
                    <path
                        fill="#8F4620"
                        d="m8.74 7.26-.03.12-.07.14s.1-.04.14-.14c.05-.1.03-.22.03-.22l-.07.1Zm.1-.1v.1l-.03.14.02.05c0 .03.05.07.08.05l.07-.07.05-.12.02.02.03.05.07.05.02-.05-.05-.15-.07-.14-.02-.05H8.9l-.08.12h.02Z"
                    />
                    <path
                        fill="#AB6D29"
                        d="m9.03 7.04.02.12-.02.15v-.15L9 7.06l.03-.02Z"
                    />
                    <path
                        fill="#4D2A15"
                        d="M9.17 7.3v.08l-.07-.1-.05-.17-.02-.07.05-.02.1.29-.01-.01Zm-.26.18s.1-.08.12-.25l-.05-.19s0 .12-.05.22l-.07.14.05-.02.02-.05v.07l-.02.08Zm-.1-.32-.05.07-.1.08.08-.1v-.07l-.03.05-.07.02.02-.05v-.02l.05-.1.05.07.05.05Z"
                    />
                    <path
                        fill="#1E2121"
                        d="m9.12 6.97.05.14v.2l-.07-.12-.02-.1-.05-.05H9l.03-.05v-.05l.05.03h.04Zm-.21.36.07-.17v-.12l-.05-.02-.05-.08v.1c0 .07-.07.12-.07.12h.07c.05-.02.05-.1.05-.1v.1l-.02.17Z"
                    />
                    <path
                        fill="#8F4620"
                        d="m8.25 7.45.08-.12.07-.12h.02l.1-.05.05-.1s-.03.08.02.1l.05.05-.02.1-.03.12V7.3c-.02-.03-.02 0-.05.04l-.02.05.02-.07v-.05h-.02l.02-.07.03-.02v-.05l-.05.05-.05.04-.05.1-.02.1-.03.02.03-.1.05-.12a.02.02 0 1 0-.05 0l-.07.1c-.05.05-.03.12-.03.12h-.05v.01Z"
                    />
                    <path
                        fill="#874F20"
                        d="m9.17 6.92-.05.05h-.07l-.02-.07.14.02Z"
                    />
                    <path
                        fill="#B27129"
                        d="m8.42 7.04-.02.07-.05.08.05.02.05-.17h-.03Z"
                    />
                    <path
                        fill="#DBAD6C"
                        d="M8.9 6.92s-.02.24-.1.24c-.04 0-.09-.12-.09-.12s0 .17-.07.17c-.05 0-.1-.12-.07-.15l-.08.13c-.07.04-.12.02-.12.02s.08-.1.08-.17l.02-.02.05-.08.12-.02.05-.07h.05c.04-.03.04-.08.04-.08l.1.1.03.05H8.9Z"
                    />
                    <path
                        fill="#B27129"
                        d="m8.64 6.7.1.15.02-.03.02.05c-.02.03-.04.1-.02.15v-.08l.02-.04.05.21.03-.17c0-.07.02-.02.02 0 0 .03.07.12.12.1.05-.02.05-.1.05-.12L9 6.77l-.22-.14-.02.07h-.12Z"
                    />
                    <path
                        fill="#8F4620"
                        d="m8.95 6.68.05.07c0 .05.03.24-.02.24l-.1-.07V6.8l-.05-.12V6.6h.05l.07.08Z"
                    />
                    <path
                        fill="#4D2A15"
                        d="m8.93 6.63.1.14.1.13.04.02c0 .02-.05.05-.12 0-.05 0-.02-.07-.07-.17a.33.33 0 0 0-.1-.12l.03-.03.02.03Z"
                    />
                    <path
                        fill="#1E2121"
                        d="m8.88 6.56.12.12.1.14.07.1-.05-.02-.04-.05-.1-.15-.1-.07.07.07c.05.05.05.12.05.12l-.05-.07-.12-.12.08.1.04.14-.07-.12-.07-.07-.05-.08h.07l.05-.04Z"
                    />
                    <path
                        fill="#8F4620"
                        d="m8.66 6.7.1.03.02-.03.03.07-.03.08-.02-.08-.1-.07Z"
                    />
                    <path
                        fill="#B27129"
                        d="m8.69 6.85.02.14c0 .07-.07.17-.07.17l-.02-.14-.03.04.03-.1v-.02l.04-.07.03-.02Z"
                    />
                    <path
                        fill="#8F4620"
                        d="m8.6 6.92-.08.02-.03.03h.03v.05c0 .04-.07.12-.07.12l.1-.1.02-.07.05-.03.02.03v.1l.05-.1v-.12h-.03l-.04-.03-.03.1h.01Z"
                    />
                    <path
                        fill="#DBAD6C"
                        d="M8.88 6.48s.03.08-.02.1l-.05.02-.05-.02-.14-.05-.1-.02-.03-.03v-.02h.13l.1.05h.04l.05.02h.02l.03-.02h.02v-.03Z"
                    />
                    <path
                        fill="#AB6D29"
                        d="M8.88 6.48v.05h-.1l-.12-.05-.12-.02-.02-.02.17.02.14.05.05-.03Z"
                    />
                    <path fill="#4D2A15" d="M8.5 6.44h.04v.02H8.5v-.02Z" />
                    <path
                        fill="#DBAD6C"
                        d="M8.78 6.63s.05.05.03.07l-.1-.02-.14-.08-.1-.02v-.02l.02-.03v-.02h.1l.12.05.07.07Zm-.12.07s.1.1.08.15l-.22-.12-.07.12-.17-.1.17-.12V6.6h.1l.11.05v.05Z"
                    />
                    <path
                        fill="#AB6D29"
                        d="m8.62 6.5.12.06.12.02s-.03.05-.08.05l-.07-.05-.1-.05v-.02l.01-.01Z"
                    />
                    <path
                        fill="#4D2A15"
                        d="m8.5 6.48.07.03h.07l-.02.02-.08-.02H8.5v-.03Z"
                    />
                    <path
                        fill="#AB6D29"
                        d="m8.78 6.68.03.02-.05.03H8.7l-.1-.08-.1-.05h-.04l.02-.02.12.02.1.03.07.05h.02-.01Zm-.19.07.03.1-.03.07h-.07v-.05l-.07-.05.04-.07.03-.05.07.05Z"
                    />
                    <path
                        fill="#4D2A15"
                        d="m8.47 6.56.05.02.07.02.05-.02-.02.02.1.03.06.05-.07-.03-.12-.05h-.14v-.02l.02-.02Z"
                    />
                    <path
                        fill="#AB6D29"
                        d="M8.74 6.82v.03c-.03 0-.1.02-.12-.03l-.03-.05-.1-.04c-.04-.03.03-.03.03-.03l.12.05.1.07Z"
                    />
                    <path
                        fill="#4D2A15"
                        d="M8.74 6.82s-.05-.07-.2-.12h.05-.07l-.03-.02-.1-.03v.03l-.02.02h.08l.04.05-.04.07s.02-.07.07-.05l.05.03-.03-.03-.02-.04a.5.5 0 0 0 .22.1v-.01Z"
                    />
                    <path
                        fill="#DBAD6C"
                        d="M8.52 6.73s.1.02.1.14c0 .12-.1.07-.1.05h.05l.02-.07-.02-.1-.05-.02Z"
                    />
                    <path
                        fill="#6C3F18"
                        d="M8.06 6.46v.07l-.1.17-.12.12.05.03.17-.22.02-.12v-.05h-.02Z"
                    />
                    <path
                        fill="#DBAD6C"
                        d="M8.45 6.29s.04.07.02.2c-.02.11-.17.24-.17.24l-.24.14h-.12l-.05-.02-.02-.05.04-.03.08-.1.07-.07.02-.07c.03-.02-.02-.07-.02-.07l.02.02.03.08-.03.07.08-.05.07-.02.05-.05.02-.15V6.3l.03.07.02.1.05-.05.02-.05.03-.07v-.01Z"
                    />
                    <path
                        fill="#904720"
                        d="M8.47 6.92v.05c0 .05-.05.07-.05.07v-.07l-.05-.03-.07-.02h.03l.04-.05.1.05Z"
                    />
                    <path
                        fill="#AB6D29"
                        d="M8.42 6.92h.05l.02-.07-.02.05-.07-.05c-.03-.03-.05.02-.05.02-.02.03.02.03.02.03h.05v.02Z"
                    />
                    <path
                        fill="#904720"
                        d="M8.08 6.75h.08l.1-.05.07-.05c.02-.02.12-.07.12-.19v-.17s.12.15 0 .31l-.12.13h.12v.1s.07 0 .07.04l-.15-.02c-.07 0-.1.07-.1.07L8.2 6.9l-.1.02-.16-.05L8 6.8c.03-.07.07-.05.07-.05h.01Z"
                    />
                    <path
                        fill="#AB6D29"
                        d="m8.35 6.46.07-.1.03-.07-.03.1a.48.48 0 0 1-.07.07Z"
                    />
                    <path
                        fill="#904720"
                        d="M8.35 6.34s.02.17-.02.22l-.22.17.2-.17c.04-.08.02-.17.02-.17l.02-.05Z"
                    />
                    <path
                        fill="#1E2121"
                        d="m8.16 6.75.1-.02.07-.08-.05.05-.03-.05-.05.08-.04.02Zm.14-.2s.05-.07.05-.16c0-.1-.05-.1-.05-.1s.03.02.03.12l-.03.15v-.01Zm.05 0 .07-.04.03-.1-.03.07-.07.08v-.01Zm-.02.37s.02-.07.07-.05l.02.05-.05-.02-.04.02ZM8.2 6.8l.15-.03.1-.04-.1.1c-.07.04-.12.02-.12.02l.14-.08s-.12.05-.17.03Z"
                    />
                    <path fill="#fff" d="M8.08 6.68a.1.1 0 0 1-.12.17" />
                    <path fill="#F16E16" d="M8.06 6.68a.1.1 0 0 1-.1.14" />
                    <path fill="#000" d="M8.03 6.73A.04.04 0 1 1 8 6.8" />
                    <path
                        fill="#AB6D29"
                        d="m8.08 6.6.08-.12.02-.12.02.05v.15l.05-.03.05-.24v.15c-.02.12-.05.12-.12.16-.05 0-.1.05-.14.15l-.1.12.07-.12.05-.1.02-.05Z"
                    />
                    <path
                        fill="#904720"
                        d="m8.06 6.65.02-.1-.02-.09s.05 0 .05.07c0 .1-.03.1-.05.12Z"
                    />
                    <path
                        fill="#4D2A15"
                        d="m8.18 6.56.02-.1-.02-.1.05.1c.02.07-.03.07-.05.1Z"
                    />
                    <path
                        fill="#AB6D29"
                        d="m7.91 6.87-.02-.05.07-.07.07-.12c0-.03.08-.12.03-.17 0 0 .02.07-.03.14l-.12.15c-.04.02-.04.05-.04.07l.02.03.02.02Z"
                    />
                    <path
                        fill="#6C4119"
                        d="m8.42 7.04.03-.02c.02-.03 0-.03-.03-.05l-.07-.05h-.07l.05.05h.07l.02.07Z"
                    />
                    <path
                        fill="#6C4119"
                        d="M8.42 7.04s.05-.02.05-.07v-.05l.02.02h.03s-.03.1-.1.1Z"
                    />
                    <path
                        fill="#BF802D"
                        d="m8.01 7.04.05.02.02.03.15-.03.02-.04-.02-.08h-.1l-.12.1Z"
                    />
                    <path
                        fill="#F9C83A"
                        d="m8.35 7-.02-.06-.03-.02h-.17l-.05.02-.1-.04-.07-.03-.07-.02-.02.02v.05l-.03.02s-.1.05-.12.15c-.02.1.17.26.24.2 0 0-.1-.1-.07-.15.03-.05.05-.1.15-.12l.12-.03c.05-.02.1-.05.14 0 .05.05-.2.1-.2.1l.03.05s.3-.1.27-.15V7Z"
                    />
                    <mask
                        id="Q"
                        width="2"
                        height="2"
                        x="7"
                        y="6"
                        maskUnits="userSpaceOnUse"
                    >
                        <path
                            fill="#8F4620"
                            d="m8.35 7-.02-.06-.03-.02h-.17l-.05.02-.1-.04-.07-.03-.07-.02-.02.02v.05l-.03.02s-.1.05-.12.15c-.02.1.17.26.24.2 0 0-.1-.1-.07-.15.03-.05.05-.1.15-.12l.12-.03c.05-.02.1-.05.14 0 .05.05-.2.1-.2.1l.03.05s.3-.1.27-.15V7Z"
                        />
                    </mask>
                    <g mask="url(#Q)">
                        <path
                            fill="#8F4620"
                            d="m8.33 6.94.44-.22-.03-.07-.06-.06-.35.35Zm-.03-.02.35-.35-.14-.15h-.2v.5H8.3Zm-.17 0v-.5h-.12l-.1.05.22.45Zm-.05.02-.22.45.22.11.23-.1-.23-.46Zm-.1-.04.23-.45-.03-.02h-.04L8 6.9h-.02Zm-.14-.05L8 6.37l-.3-.1-.21.22.35.36Zm-.02.02-.36-.35-.14.14v.21h.5Zm0 .05.35.35.15-.14v-.21h-.5Zm-.03.02.23.45.07-.04.06-.05-.36-.36Zm.12.34.36.36.35-.36-.35-.35-.36.35ZM8 7.02l-.1-.5h-.01l-.01.01.12.49Zm.12-.03.1.5.06-.02.06-.03-.22-.45Zm-.05.1-.1-.5-.64.14.3.58.44-.22Zm.02.05-.44.22.19.39.41-.14-.16-.47Zm.72-.37-.03-.05-.9.45.03.05.9-.45Zm-.12-.18-.03-.02-.7.7.02.03.7-.71h.01Zm-.38-.17h-.17v1h.17v-1Zm-.4.05-.04.03.45.9.05-.03-.45-.9h-.01Zm.4.03-.09-.05-.45.9.1.04.45-.9-.01.01Zm-.16-.08-.07-.02-.31.95.07.02.31-.95Zm-.07-.02L8 6.37l-.32.95.08.03.31-.95h.01Zm-.58.1-.03.02.71.7.02-.02-.7-.7Zm-.17.37v.05h1v-.05h-1Zm.14-.3-.02.02.7.7.03-.02-.7-.7h-.01Zm.33.37-.22-.44a.72.72 0 0 0-.38.47l.97.24a.28.28 0 0 1-.14.18l-.23-.45Zm-.6.03c-.05.2.02.37.06.44.1.18.27.31.47.37.12.03.36.05.55-.14l-.71-.71a.43.43 0 0 1 .4-.12l.12.05a.2.2 0 0 1 .05.07c0 .02.07.12.03.28l-.97-.24Zm.72.31.36-.35v.01s.03.03.04.07c.01.03.06.18-.02.35l-.9-.45c-.1.2-.04.38-.02.44.03.1.08.18.15.25l.04.03.35-.35Zm.38.08c.01-.03 0 .02-.05.06a.3.3 0 0 1-.13.08l-.24-.97a.7.7 0 0 0-.34.18c-.08.09-.13.19-.14.2l.9.45Zm-.2.15.12-.03L8 6.5l-.12.03.2.98h.02Zm.24-.07c.02 0 .01 0 0 0a.42.42 0 0 1-.43-.1l.7-.7a.58.58 0 0 0-.48-.17c-.13.01-.23.07-.24.07l.45.9Zm-.43-.1a.48.48 0 0 1-.12-.49.5.5 0 0 1 .17-.23l.06-.03a.5.5 0 0 1-.05 0l.1.5.1.49a1.1 1.1 0 0 0 .37-.15c.04-.02.15-.1.2-.26a.51.51 0 0 0-.12-.53l-.71.7Zm-.29-.03.03.05.9-.45-.03-.04-.9.44Zm.47-.17.16.47h.02l.34-.16.14-.13a.52.52 0 0 0 .06-.55l-.9.45a.49.49 0 0 1 .15-.61l-.02.01-.1.04.15.48Z"
                        />
                    </g>
                    <path
                        fill="#FCF3D8"
                        d="M7.82 7.23s-.12-.04-.1-.14c.02-.1.1-.15.12-.15l.03-.07.07.03.05.02s-.2.1-.2.22l.03.1v-.01Z"
                    />
                    <path
                        fill="#FDEAAF"
                        d="M8.35 6.97h-.02l-.1-.05-.12.02h-.08l-.14-.07s-.05.03-.02.05c.02.02-.05 0-.05 0s.02-.07.07-.07c.1 0 .17.07.2.07l.14-.02c.07 0 .12.02.12.07Z"
                    />
                    <path
                        fill="#513625"
                        d="m8.03 7.04.08-.02.1-.03-.08.05-.07.02-.03-.02Z"
                    />
                    <path
                        fill="#F9C83A"
                        d="m7.87 7.28-.1-.05-.1-.1.05-.14c.05-.07.1-.05.1-.05L7.74 7l-.02.05-.02.05v.05l.02.05.1.07.05.02v-.01Z"
                    />
                    <path
                        fill="#8F4620"
                        d="M7.87 6.87c-.05.03-.05 0 0 0h-.05l-.03.03v.02a.02.02 0 0 0 .03.02h.05v-.02h-.05l.02-.02.03-.03v-.02c-.03 0-.05.05 0 .02Z"
                    />
                    <path
                        fill="#F9C83A"
                        d="m8.03 7-.14.02h.1l.04.02.03-.02c.05-.03.17-.05.17 0 .02.02-.15.07-.15.07v.02l.12-.05.08-.02.02-.05-.07-.05h-.1l-.05.03-.05.02V7Z"
                    />
                    <path
                        fill="#8F4620"
                        d="m7.84 7.19.05.07v.02h-.07c-.05 0-.1-.05-.15-.17v.03l.03.05.04.04.08.05.05.03.02-.03h.02l-.04-.05-.05-.07.02.03Z"
                    />
                    <path
                        fill="#FCCA3D"
                        d="m8.3 8.42-.02.05-.03-.03.03-.04.02.02Zm-.2-1.28-.04-.05h-.03l.05.07.03-.02H8.1Z"
                    />
                    <path
                        fill="#816C2A"
                        d="m8.28 8.52-.05-.03c.02 0 .03.02.05.03Zm0-.13h-.1l-.05.03v.02a.14.14 0 0 1 .05-.02h.1v-.03Zm0-.1-.1.06-.07.04.02.03v-.03l.05-.02.05-.05h.05v-.03ZM8.2 8.2v.05l-.02.02-.07.08-.03.02v.02l.1-.12.02-.02.03-.05H8.2Zm-.07-.05v.1l-.05.07-.02.03v.02h.02l.05-.12a.17.17 0 0 0 .03-.07l-.03-.03Zm-.07 0v.05l-.03.05-.02.07v.05l.05-.12v-.1Zm-.07 0v.12l-.03.08.03.02v-.1L8 8.15h-.01Zm-.05 0v.12l-.03.08.03-.03v-.17Zm-.07.03v.07l-.03.07v.05l.03-.12.02-.07v-.03l-.02.03Zm-.05 0v.1l-.08.04-.02.03.1-.08.02-.07v-.05l-.02.03Zm-.03-.03-.05.08-.04.04-.03.03.1-.05.02-.1Zm-.07-.02v.02l-.02.03-.03.02-.02.03h.02l.03-.05.02-.03.02-.02h-.02ZM7.7 8.1l-.05.03v.02l.07-.05H7.7Zm0-.02h-.03l-.02.02h-.03v.03l.03-.03.05-.02Zm-.03-.02h-.02l-.03.02.08-.02h-.03Zm0-.08-.02.03h.02v-.03Zm0-.07-.02.03-.03.02a.02.02 0 0 1 0 .02l.03-.04h.02V7.9v.01Zm.39-.5h.05l.02-.03.03-.03h-.03l-.02.03-.03.02h-.02v.01Zm0-.06.02-.02.05-.02.05-.03h-.02l-.05.03-.05.02v.02Zm-.03-.04.08-.05.05-.05-.08.05-.05.02v.03Zm-.02-.08.12-.07v-.02l-.12.1v-.01Zm-.05-.04.05-.05.07-.05-.07.02-.07.05.02.03Zm-.05-.05.05-.03.05-.05h.02v-.02l-.02.02-.1.08Z"
                    />
                    <path
                        fill="#78732E"
                        d="m8.01 7.04.1.1.07.14v.03l-.1.17-.26.24-.12.12c-.05.05-.03.07-.03.12v.02l.03.12c.02.05.07.05.12.08h.02l.22-.03c.05 0 .12 0 .17.08.05.04.05.12.05.19v.17l-.03.07.05-.24-.07-.22a.26.26 0 0 0-.17-.07l-.22.02h-.02c-.05 0-.08-.02-.1-.07l-.05-.12.07-.15.27-.24c.1-.07.17-.17.17-.26v-.03c0-.07-.05-.12-.07-.17a.63.63 0 0 0-.1-.1v.03Z"
                    />
                    <path
                        fill="#A8AC71"
                        d="M7.91 7.14H7.9l.02.02v-.02h-.01Zm.05.05-.02-.03v.03h.02Z"
                    />
                    <path
                        fill="#78732E"
                        d="m8.06 7.3-.03-.02v.03h.03V7.3Zm.02.1v-.02h-.02v.02h.02Zm-.02.05.02-.02h-.02v.02Zm-.44.53v-.02l-.02.02h.02Zm0 .1H7.6v.02l.02-.02Z"
                    />
                    <path fill="#fff" d="M7.65 8.23V8.2l-.03.03h.03Z" />
                    <path
                        fill="#A8AC71"
                        d="M7.74 8.35h-.02v.02l.02-.02Zm.37.05-.03-.03v.03h.03Z"
                    />
                </g>
            </g>
            <defs>
                <radialGradient
                    id="B"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientTransform="translate(8.02917 9.16644) rotate(16.3975) scale(0.102954 0.0964605)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#fff" />
                    <stop offset="1" stopColor="#F15770" />
                </radialGradient>
                <radialGradient
                    id="C"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientTransform="translate(6.93322 8.72544) rotate(-18.3506) scale(0.100529 0.0939131)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#fff" />
                    <stop offset="1" stopColor="#F15770" />
                </radialGradient>
                <radialGradient
                    id="F"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientTransform="translate(10.5629 9.51417) rotate(-141.264) scale(0.102843 0.107035)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#fff" />
                    <stop offset="1" stopColor="#F15770" />
                </radialGradient>
                <clipPath id="a">
                    <path fill="#fff" d="M0 0h18v18H0z" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default Mexico
